import { useState, useEffect } from "react";
// import { useGetUsersQuery } from "../users/usersApiSlice";
import {
  useGetAllCiljeviQuery,
  useDeleteCiljMutation,
  useAddNewCiljMutation,
  useUpdateCiljMutation,
  useGetAllSpecCiljeviQuery,
  useAddNewSpecCiljMutation,
  useUpdateSpecCiljMutation,
  useDeleteSpecCiljMutation,
  useGetAllMotivacijeQuery,
  useAddNewMotivacijaMutation,
  useUpdateMotivacijaMutation,
  useDeleteMotivacijaMutation,
} from "../ciljevi/ciljeviApiSlice";
import {
  useGetAllFizickeAktivnostiQuery,
  useAddNewFizickuAktivnostMutation,
  useUpdateFizickuAktivnostMutation,
  useUpdateDijagnozuMutation,
  useDeleteFizickuAktivnostMutation,
  useGetAllDijagnozeQuery,
  useAddNewDijagnozuMutation,
  useDeleteDijagnozuMutation,
} from "../fizickaAktivnost/fizickaAktivnostApiSlice";
import {
  useGetAllIshraneQuery,
  useAddNewIshranaMutation,
} from "../ishrana/ishranaApiSlice";
import {
  useGetpromptsQuery,
  useUpdatepromptMutation,
} from "./promptoviApiSlice";
import IshranaForm from "../../components/IshranaForm";
import NamirnicaForm from "../../components/NamirnicaForm";
import SpecCilj from "../../components/SpecCilj";
import {
  useGetChatKonvQuery,
  useDeleteChatKonvMutation,
} from "./chatKonverzacijaApiSlice";

import {
  useGetKodsQuery,
  useAddNewKodMutation,
  useDeleteKodMutation,
} from "../kodovi/kodoviApiSlice";

let Podesavanja = () => {
  //Tab
  const [currentTab, setCurrentTab] = useState("Ciljevi");
  const [currentSubTab, setCurrentSubTab] = useState("Primarni cilj ishrane");
  const [currentSubTabParams, setCurrentSubTabParams] = useState(
    "Vrsta fizičke aktivnosti"
  );
  const [currentSubTabDiet, setCurrentSubTabDiet] = useState("Tipovi ishrane");
  const [currentSubTabPrompt, setCurrentSubTabPrompt] = useState("Promptovi");
  const [currentSubTabChetConv, setCurrentSubTabChetConv] =
    useState("Čet konverzcija");

  const [primCiljevi, setPrimCiljevi] = useState([]);
  const [specCiljevi, setSpecCiljevi] = useState([]);
  const [fizAktinosti, setFizAktinosti] = useState([]);
  const [dijagnoze, setDijagnoze] = useState([]);
  const [motivi, setMotivi] = useState([]);
  const [sviChetovi, setSviChetovi] = useState([]);
  const [sviKodovi, setSviKodovi] = useState([]);

  const [primCiljNaziv, setPrimCiljNaziv] = useState("");
  // const [specCiljNaziv, setSpecCiljNaziv] = useState('');
  const [fizAktNaziv, setFizAktNaziv] = useState("");
  const [dijagnozaNaziv, setDijagnozaNaziv] = useState("");
  const [motivNaziv, setMotivNaziv] = useState("");
  const [ishranaNaziv, setIshranaNaziv] = useState(""); //Ishrana

  const [kodNaziv, setKodNaziv] = useState(""); //Kod
  const [idUseraZaKod, setIdUseraZaKod] = useState("");
  const [opisKod, setOpisKod] = useState("");

  //Promptovi - text
  const [uvodPrompt, setUvodPrompt] = useState("");
  const [holistickiPrompt, setHolistickiPrompt] = useState("");
  const [planIshranePrompt, setPlanIshranePrompt] = useState("");
  const [smernicePrompt, setSmernicePrompt] = useState("");
  const [fizickaAktivnostPrompt, setFizickaAktivnostPrompt] = useState("");
  const [imunitetPrompt, setImunitetPrompt] = useState("");
  const [sanPrompt, setSanPrompt] = useState("");
  const [vodaPrompt, setVodaPrompt] = useState("");
  const [pretIskPrompt, setPretIskPrompt] = useState("");
  const [alerginPrompt, setAlerginPrompt] = useState("");
  const [alkoholPrompt, setAlkoholPrompt] = useState("");
  const [pusenjePrompt, setPusenjePrompt] = useState("");
  const [zakljucakPrompt, setZakljucakPrompt] = useState("");

  const updateUvodPrompt = (e) => setUvodPrompt(e.target.value);
  const updateHolistickiPrompt = (e) => setHolistickiPrompt(e.target.value);
  const updatePlanIshranePrompt = (e) => setPlanIshranePrompt(e.target.value);
  const updateSmernicePrompt = (e) => setSmernicePrompt(e.target.value);
  const updateFizickaAktivnostPrompt = (e) =>
    setFizickaAktivnostPrompt(e.target.value);
  const updateImunitetPrompt = (e) => setImunitetPrompt(e.target.value);
  const updateSanPrompt = (e) => setSanPrompt(e.target.value);
  const updateVodaPrompt = (e) => setVodaPrompt(e.target.value);
  const updatePretIskPrompt = (e) => setPretIskPrompt(e.target.value);
  const updateAlerginPrompt = (e) => setAlerginPrompt(e.target.value);
  const updateAlkoholPrompt = (e) => setAlkoholPrompt(e.target.value);
  const updatePusenjePrompt = (e) => setPusenjePrompt(e.target.value);
  const updateZakljucakPrompt = (e) => setZakljucakPrompt(e.target.value);

  //Promptovi - broj karaktera za taj prompt
  const [brKarUvod, setBrKarUvod] = useState("");
  const [brKarHol, setBrKarHol] = useState("");
  const [planIshBrKar, setPlanIshBrKar] = useState("");
  const [smerniceBrKar, setSmerniceBrKar] = useState("");
  const [fizAktBrKar, setFizAktBrKar] = useState("");
  const [imunBrKar, setImunBrKar] = useState("");
  const [sanBrKar, setSanBrKar] = useState("");
  const [vodaBrKar, setVodaBrKar] = useState("");
  const [pretIskBrKar, setPretIskBrKar] = useState("");
  const [alerIshBrKar, setAlerIshBrKar] = useState("");
  const [alkoholBrKar, setAlkoholBrKar] = useState("");
  const [pusenjeBrKar, setPusenjeBrKar] = useState("");
  const [zakljucakBrKar, setZakljucakBrKar] = useState("");

  const handleEditbrKarUvod = (e) => setBrKarUvod(e.target.value);
  const handleEditbrKarHol = (e) => setBrKarHol(e.target.value);
  const handleEditPlanIshBrKar = (e) => setPlanIshBrKar(e.target.value);
  const handleEditSmerniceBrKar = (e) => setSmerniceBrKar(e.target.value);
  const handleEditFizAktBrKar = (e) => setFizAktBrKar(e.target.value);
  const handleEditImunBrKar = (e) => setImunBrKar(e.target.value);
  const handleEditSanBrKar = (e) => setSanBrKar(e.target.value);
  const handleEditVodaBrKar = (e) => setVodaBrKar(e.target.value);
  const handleEditPretIskBrKar = (e) => setPretIskBrKar(e.target.value);
  const handleEditAlerIshBrKar = (e) => setAlerIshBrKar(e.target.value);
  const handleEditAlkoholBrKar = (e) => setAlkoholBrKar(e.target.value);
  const handleEditPusenjeBrKar = (e) => setPusenjeBrKar(e.target.value);
  const handleEditZakljucakBrKar = (e) => setZakljucakBrKar(e.target.value);

  //Za chat
  const [selectedChat, setSelectedChat] = useState(null);
  const [isModalOpenChat, setIsModalOpenChat] = useState(false);

  // Funkcija za otvaranje modala
  const openModalChat = (chat) => {
    setSelectedChat(chat);
    setIsModalOpenChat(true);
  };

  // Funkcija za zatvaranje modala
  const closeModalChat = () => {
    setSelectedChat(null);
    setIsModalOpenChat(false);
  };

  const [tips, setTips] = useState([]);
  const [newTipName, setNewTipName] = useState("");
  const [newPodtipName, setNewPodtipName] = useState("");
  const [newNamirnica, setNewNamirnica] = useState({
    ime: "",
    Gluten: false,
    Laktoza: false,
    Alergen: false,
    Ishrana: [],
  });

  // Add this part at the top where other useState hooks are defined
  const [nazivIshrane, setNazivIshrane] = useState(""); // Track Naziv Ishrane
  const [komentarIshrane, setKomentarIshrane] = useState(""); // Track Komentar Ishrane

  // Function to remove a Tip
  const handleRemoveTip = (tipIndex) => {
    const updatedTips = [...tips];
    updatedTips.splice(tipIndex, 1);
    setTips(updatedTips);
  };

  // Function to remove a Podtip from a selected Tip
  const handleRemovePodtip = (podtipIndex) => {
    const updatedTips = [...tips];
    updatedTips[selectedTipIndex].podtipovi.splice(podtipIndex, 1);
    setTips(updatedTips);
  };

  // Function to remove a Namirnica from a selected Podtip
  const handleRemoveNamirnica = (namirnicaToRemove, podtipIndex) => {
    const updatedTips = [...tips];
    const selectedTip = updatedTips[selectedTipIndex];
    const selectedPodtip = selectedTip.podtipovi[podtipIndex];
    selectedPodtip.namirnice = selectedPodtip.namirnice.filter(
      (n) => n !== namirnicaToRemove
    );
    setTips(updatedTips);
  };

  // Add new Tip
  const handleAddTip = () => {
    if (newTipName.trim() === "") {
      alert("Naziv tipa ne sme biti prazan!");
      return;
    }
    const newTip = { ime: newTipName, podtipovi: [] };
    setTips([...tips, newTip]);
    setNewTipName("");
  };

  // Add new Podtip to the selected Tip
  const handleAddPodtip = () => {
    if (newPodtipName.trim() === "") {
      alert("Naziv podtipa ne sme biti prazan!");
      return;
    }
    if (selectedTipIndex === "") {
      alert("Morate izabrati tip pre dodavanja podtipa!");
      return;
    }
    const updatedTips = [...tips];
    updatedTips[selectedTipIndex].podtipovi.push({
      ime: newPodtipName,
      namirnice: [],
    });
    setTips(updatedTips);
    setNewPodtipName("");
  };

  const handleDefineNamirnica = () => {
    if (newNamirnica.ime.trim() === "") {
      alert("Naziv namirnice ne sme biti prazan!");
      return;
    }

    // Create the Namirnica without requiring an Ishrana
    const updatedNamirnica = {
      ...newNamirnica,
      Ishrana: selectedIshrana ? [selectedIshrana] : [], // Add Ishrana only if it's selected, otherwise leave it empty
    };

    // Add the Namirnica to the list
    setAvailableNamirnice([...availableNamirnice, updatedNamirnica]);

    // Reset form fields
    setNewNamirnica({
      ime: "",
      Gluten: false,
      Laktoza: false,
      Alergen: false,
      Ishrana: [],
    });
    setSelectedIshrana(""); // Reset selected Ishrana after adding
  };

  // Function to handle selecting and deselecting Namirnice for the selected Podtip
  const handleSelectNamirnica = (namirnica) => {
    if (selectedNamirnice.includes(namirnica)) {
      // If already selected, remove from selectedNamirnice
      setSelectedNamirnice(selectedNamirnice.filter((n) => n !== namirnica));
    } else {
      // Otherwise, add to selectedNamirnice
      setSelectedNamirnice([...selectedNamirnice, namirnica]);
    }
  };

  // Add selected Namirnice to the selected Podtip
  const handleAddNamirniceToPodtip = () => {
    if (selectedNamirnice.length === 0) {
      alert("Morate izabrati barem jednu namirnicu!");
      return;
    }
    if (selectedTipIndex === "" || selectedPodtipIndex === "") {
      alert("Morate izabrati tip i podtip!");
      return;
    }
    const updatedTips = [...tips];
    const selectedTip = updatedTips[selectedTipIndex];
    const selectedPodtip = selectedTip.podtipovi[selectedPodtipIndex];

    if (selectedPodtip) {
      selectedPodtip.namirnice.push(...selectedNamirnice);
      setTips(updatedTips);
      setSelectedNamirnice([]); // Clear selected Namirnice after adding
      setShowModal(false); // Close the modal
    }
  };

  const [selectedIshrana, setSelectedIshrana] = useState(""); // Track selected Ishrana for Namirnica
  const [ishrane, setIshrane] = useState([]); // List of available Ishrane
  const [selectedTipIndex, setSelectedTipIndex] = useState(""); // Track the currently selected Tip
  const [selectedPodtipIndex, setSelectedPodtipIndex] = useState(""); // Track the selected Podtip within the selected Tip
  const [availableNamirnice, setAvailableNamirnice] = useState([]); // Track all defined Namirnice
  const [selectedNamirnice, setSelectedNamirnice] = useState([]); // Track the selected Namirnice for Podtip
  const [showModal, setShowModal] = useState(false); // Track modal visibility

  //Liste namirnica
  //selectedFruits - cirtus, selectedFruitsBobicasto, selectedFruitsKostunjavo, selectedFruitsJabIKru, selectedFruitsLub, selectedFruitsTrop, selectedFruitsLiPo
  //selectedFruitsKoPo, selectedFruitsTik, selectedFruitsLuPo, selectedFruitsPaPa, selectedFruitsMah, selectedFruitsOrPl, selectedFruitsSem, selectedFruitsCeZi
  //selectedFruitsRaZi, selectedFruitsPcz, selectedFruitsMl, selectedFruitsJo, selectedFruitsSi, selectedFruitsKiMl, selectedFruitsPaMa, selectedFruitsCm
  //selectedFruitsBm, selectedFruitsRimp, selectedFruitsPrer, selectedFruitsJaja, selectedFruitsBiUl, selectedFruitsMim, selectedFruitsSiz, selectedFruitsSok
  //selectedFruitsKic, selectedFruitsAlk, selectedFruitsBp,

  //Modali za primarni cilj
  const [isEditModalOpenPrimCilj, setIsEditModalOpenPrimCilj] = useState(false);
  const [inputValuePrimCilj, setInputValuePrimCilj] = useState("");
  const [selectedJobPrimCilj, setSelectedJobPrimCilj] = useState(null);

  //Modali za specifican cilj
  const [isEditModalOpenSpecCilj, setIsEditModalOpenSpecCilj] = useState(false);
  const [inputValueSpecCilj, setInputValueSpecCilj] = useState("");
  const [selectedJobSpecCilj, setSelectedJobSpecCilj] = useState(null);

  //Modali za motiv
  const [isEditModalOpenMotiv, setIsEditModalOpenMotiv] = useState(false);
  const [inputValueMotiv, setInputValueMotiv] = useState("");
  const [selectedJobMotiv, setSelectedJobMotiv] = useState(null);

  //Modali Fizicke aktivnosti
  const [isEditModalOpenFizAkt, setIsEditModalOpenFizAkt] = useState(false);
  const [inputValueFizAkt, setInputValueFizAkt] = useState("");
  const [selectedJobFizAkt, setSelectedJobFizAkt] = useState(null);

  //Modali Dijagnoze moda
  const [isEditModalOpenDijagnoza, setIsEditModalOpenDijagnoza] =
    useState(false);
  const [inputValueDijagnoza, setInputValueDijagnoza] = useState("");
  const [selectedJobDijagnoza, setSelectedJobDijagnoza] = useState(null);

  // const {
  //   data: users,
  // } = useGetUsersQuery("usersList", {
  //   pollingInterval: 60000,
  //   refetchOnFocus: true,
  //   refetchOnMountOrArgChange: true,
  // });

  //Za primarne
  const {
    isSuccess: isSuccessGetCiljevi,
    isError: isErrorGetCiljevi,
    error: getCiljeviError,
    data: getCiljeviData,
  } = useGetAllCiljeviQuery();
  const [
    addCilj,
    {
      isSuccess: isSuccessAddCilj,
      isError: isErrorAddCilj,
      error: errorAddCilj,
      data: dataAddCilj,
    },
  ] = useAddNewCiljMutation();
  const [
    updateCilj,
    {
      isSuccess: isSuccessUpdateCilj,
      isError: isErrorUpdateCilj,
      error: errorUpdateCilj,
      data: dataUpdateCilj,
    },
  ] = useUpdateCiljMutation();
  const [
    delCilj,
    {
      isSuccess: isSuccessDelCilj,
      isError: isErrorDelCilj,
      error: errorDelCilj,
      data: dataDelCilj,
    },
  ] = useDeleteCiljMutation();

  //Za spec
  const {
    isSuccess: isSuccessGetSpecCiljevi,
    isError: isErrorGetSpecCiljevi,
    error: getSpecCiljeviError,
    data: getSpecCiljeviData,
  } = useGetAllSpecCiljeviQuery();
  const [
    addSpecCilj,
    {
      isSuccess: isSuccessAddSpecCilj,
      isError: isErrorAddSpecCilj,
      error: errorAddSpecCilj,
      data: dataAddSpecCilj,
    },
  ] = useAddNewSpecCiljMutation();
  const [
    updateSpecCilj,
    {
      isSuccess: isSuccessUpdateSpecCilj,
      isError: isErrorUpdateSpecCilj,
      error: errorUpdateSpecCilj,
      data: dataUpdateSpecCilj,
    },
  ] = useUpdateSpecCiljMutation();
  const [
    delSpecCilj,
    {
      isSuccess: isSuccessDelSpecCilj,
      isError: isErrorDelSpecCilj,
      error: errorDelSpecCilj,
      data: dataDelSpecCilj,
    },
  ] = useDeleteSpecCiljMutation();

  //Za fizicku aktivnost
  const {
    isSuccess: isSuccessGetFizAkt,
    isError: isErrorGetFizAkt,
    error: getFizAktError,
    data: getFizAktData,
  } = useGetAllFizickeAktivnostiQuery();
  const [
    addFizAkt,
    {
      isSuccess: isSuccessAddFizAkt,
      isError: isErrorAddFizAkt,
      error: errorAddFizAkt,
      data: dataAddFizAkt,
    },
  ] = useAddNewFizickuAktivnostMutation();
  const [
    updateFizAkt,
    {
      isSuccess: isSuccessUpdateFizAkt,
      isError: isErrorUpdateFizAkt,
      error: errorUpdateFizAkt,
      data: dataUpdateFizAkt,
    },
  ] = useUpdateFizickuAktivnostMutation();
  const [
    delFizAkt,
    {
      isSuccess: isSuccessDelFizAkt,
      isError: isErrorDelFizAkt,
      error: errorDelFizAkt,
      data: dataDelFizAkt,
    },
  ] = useDeleteFizickuAktivnostMutation();

  //Za dijagnozu
  const {
    isSuccess: isSuccessGetDijagnoza,
    isError: isErrorGetDijagnoza,
    error: getDijagnozaError,
    data: getDijagnozaData,
  } = useGetAllDijagnozeQuery();
  const [
    addDijagnoza,
    {
      isSuccess: isSuccessAddDijagnoza,
      isError: isErrorAddDijagnoza,
      error: errorAddDijagnoza,
      data: dataAddDijagnoza,
    },
  ] = useAddNewDijagnozuMutation();
  const [
    updateDijagnoza,
    {
      isSuccess: isSuccessUpdateDijagnoza,
      isError: isErrorUpdateDijagnoza,
      error: errorUpdateDijagnoza,
      data: dataUpdateDijagnoza,
    },
  ] = useUpdateDijagnozuMutation();
  const [
    delDijagnoza,
    {
      isSuccess: isSuccessDelDijagnoza,
      isError: isErrorDelDijagnoza,
      error: errorDelDijagnoza,
      data: dataDelDijagnoza,
    },
  ] = useDeleteDijagnozuMutation();

  //Za motiv
  const {
    isSuccess: isSuccessGetMotiv,
    isError: isErrorGetMotiv,
    error: getMotivError,
    data: getMotivData,
  } = useGetAllMotivacijeQuery();
  const [
    addMotiv,
    {
      isSuccess: isSuccessAddMotiv,
      isError: isErrorAddMotiv,
      error: errorAddMotiv,
      data: dataAddMotiv,
    },
  ] = useAddNewMotivacijaMutation();
  const [
    updateMotiv,
    {
      isSuccess: isSuccessUpdateMotiv,
      isError: isErrorUpdateMotiv,
      error: errorUpdateMotiv,
      data: dataUpdateMotiv,
    },
  ] = useUpdateMotivacijaMutation();
  const [
    delMotiv,
    {
      isSuccess: isSuccessDelMotiv,
      isError: isErrorDelMotiv,
      error: errorDelMotiv,
      data: dataDelMotiv,
    },
  ] = useDeleteMotivacijaMutation();

  //Ishrana
  const {
    isSuccess: isSuccessGetIshrana,
    isError: isErrorGetIshrana,
    error: getIshranaError,
    data: getIshranaData,
  } = useGetAllIshraneQuery();
  const [
    addIshrana,
    {
      isSuccess: isSuccessAddIshrana,
      isError: isErrorAddIshrana,
      error: errorAddIshrana,
      data: dataAddIshrana,
    },
  ] = useAddNewIshranaMutation();
  // const [updateCilj, { isSuccess: isSuccessUpdateCilj, isError: isErrorUpdateCilj, error: errorUpdateCilj, data: dataUpdateCilj }] = useUpdateCiljMutation();
  // const [delCilj, { isSuccess: isSuccessDelCilj, isError: isErrorDelCilj, error: errorDelCilj, data: dataDelCilj }] = useDeleteCiljMutation();

  //Promptovi
  const {
    isSuccess: isSuccessGetPrompt,
    isError: isErrorGetPrompt,
    error: getPromptError,
    data: getPrompt,
  } = useGetpromptsQuery();
  const [
    updatePrompt,
    {
      isSuccess: isSuccessUpdatePrompt,
      isError: isErrorUpdatePrompt,
      error: errorUpdatePrompt,
      data: dataUpdatePrompt,
    },
  ] = useUpdatepromptMutation();

  //Chen converstion
  const {
    isSuccess: isSuccessGetChatKonv,
    isError: isErrorGetChatKonv,
    error: getChatKonvError,
    data: getChatKonvData,
  } = useGetChatKonvQuery();
  const [
    delChatKonv,
    {
      isSuccess: isSuccessDelChatKonv,
      isError: isErrorDelChatKonv,
      error: errorDelChatKonv,
      data: dataDelChatKonv,
    },
  ] = useDeleteChatKonvMutation();

  //Kodovi
  const {
    isSuccess: isSuccessGetKodovi,
    isError: isErrorGetKodovi,
    error: getKodoviError,
    data: getKodovi,
  } = useGetKodsQuery();

  const [
    addkod,
    {
      isSuccess: isSuccessAddKod,
      isError: isErrorAddKod,
      error: errorAddKod,
      data: dataAddKod,
    },
  ] = useAddNewKodMutation();

  const [
    delKod,
    {
      isSuccess: isSuccessDelKod,
      isError: isErrorDelKod,
      error: errorDelKod,
      data: dataDelKod,
    },
  ] = useDeleteKodMutation();

  //Get prompt
  useEffect(() => {
    if (isSuccessGetPrompt) {
      // console.log("Success response:", Object.values(getCiljeviData.entities || {}));

      // console.log('prompts: ', Object.values(getPrompt.entities || {})) //Je lista zaporavo do jednog prompta
      //Postavljamo text

      let prompt = Object.values(getPrompt.entities)[0];

      setUvodPrompt(prompt?.uvod?.text);
      setHolistickiPrompt(prompt?.holisticki?.text);
      setPlanIshranePrompt(prompt?.planIsh?.text);
      setSmernicePrompt(prompt?.smernice?.text);
      setFizickaAktivnostPrompt(prompt?.fizAkt?.text);
      setImunitetPrompt(prompt?.imun?.text);
      setSanPrompt(prompt?.san?.text);
      setVodaPrompt(prompt?.voda?.text);
      setPretIskPrompt(prompt?.predijeta?.text);
      setAlerginPrompt(prompt?.alergiio?.text);
      setAlkoholPrompt(prompt?.alk?.text);
      setPusenjePrompt(prompt?.pus?.text);
      setZakljucakPrompt(prompt?.zakljucak?.text);

      //Postavljamo br karaktera
      setBrKarUvod(prompt?.uvod?.brKar);
      setBrKarHol(prompt?.holisticki?.brKar);
      setPlanIshBrKar(prompt?.planIsh?.brKar);
      setSmerniceBrKar(prompt?.smernice?.brKar);
      setFizAktBrKar(prompt?.fizAkt?.brKar);
      setImunBrKar(prompt?.imun?.brKar);
      setSanBrKar(prompt?.san?.brKar);
      setVodaBrKar(prompt?.voda?.brKar);
      setPretIskBrKar(prompt?.predijeta?.brKar);
      setAlerIshBrKar(prompt?.alergiio?.brKar);
      setAlkoholBrKar(prompt?.alk?.brKar);
      setPusenjeBrKar(prompt?.pus?.brKar);
      setZakljucakBrKar(prompt?.zakljucak?.brKar);
    }

    if (isErrorGetPrompt) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getPrompt?.data?.message;
      alert(errorMessage);
    }
  }, [
    isSuccessGetPrompt,
    isErrorGetPrompt,
    getPromptError,
    getPrompt,
    currentSubTabPrompt,
  ]);

  //currentSubTabPrompt

  //Update prompt proveriKod
  useEffect(() => {
    if (isSuccessUpdatePrompt) {
      alert(dataUpdatePrompt.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorUpdatePrompt) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorUpdatePrompt?.data?.message);
    }
  }, [
    isSuccessUpdatePrompt,
    isErrorUpdatePrompt,
    errorUpdatePrompt,
    dataUpdatePrompt,
  ]);

  let updatePrompts = async () => {
    let promptText = {
      uvodPrompt,
      holistickiPrompt,
      planIshranePrompt,
      smernicePrompt,
      fizickaAktivnostPrompt,
      imunitetPrompt,
      sanPrompt,
      vodaPrompt,
      pretIskPrompt,
      alerginPrompt,
      alkoholPrompt,
      pusenjePrompt,
      zakljucakPrompt,
    };
    let promptBr = {
      brKarUvod,
      brKarHol,
      planIshBrKar,
      smerniceBrKar,
      fizAktBrKar,
      imunBrKar,
      sanBrKar,
      vodaBrKar,
      pretIskBrKar,
      alerIshBrKar,
      alkoholBrKar,
      pusenjeBrKar,
      zakljucakBrKar,
    };

    try {
      await updatePrompt({ prompt: "1", promptText, promptBr });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  //Get prim ciljevi
  useEffect(() => {
    if (isSuccessGetCiljevi) {
      // console.log("Success response:", Object.values(getCiljeviData.entities || {}));

      setPrimCiljevi(Object.values(getCiljeviData.entities || {}));

      // data objekat je dobar response message
      // const successMessage = getCiljeviData?.message
    }

    if (isErrorGetCiljevi) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getCiljeviError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetCiljevi, isErrorGetCiljevi, getCiljeviError, getCiljeviData]);

  //Get kodovi
  useEffect(() => {
    if (isSuccessGetKodovi) {
      // console.log("Success response:", Object.values(getCiljeviData.entities || {}));

      setSviKodovi(Object.values(getKodovi.entities || {}));

      // data objekat je dobar response message
      // const successMessage = getCiljeviData?.message
    }

    if (isErrorGetKodovi) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getKodoviError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetKodovi, isErrorGetKodovi, getKodoviError, getKodovi]);

  //Add prim cilj
  useEffect(() => {
    if (isSuccessAddCilj) {
      alert(dataAddCilj.message.toString());
      setPrimCiljNaziv("");
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorAddCilj) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorAddCilj?.data?.message);
    }
  }, [isSuccessAddCilj, isErrorAddCilj, errorAddCilj, dataAddCilj]);

  //Update prim cilj
  useEffect(() => {
    if (isSuccessUpdateCilj) {
      alert(dataUpdateCilj.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorUpdateCilj) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorUpdateCilj?.data?.message);
    }
  }, [isSuccessUpdateCilj, isErrorUpdateCilj, errorUpdateCilj, dataUpdateCilj]);

  //Del prim cilj
  useEffect(() => {
    if (isSuccessDelCilj) {
      alert(dataDelCilj);
      // console.log('delleted', dataDelCilj)
    }

    if (isErrorDelCilj) {
      alert(errorDelCilj?.data?.message);
    }
  }, [isSuccessDelCilj, isErrorDelCilj, errorDelCilj, dataDelCilj]);

  //Get spec ciljevi
  useEffect(() => {
    if (isSuccessGetSpecCiljevi) {
      // console.log("Success response:", Object.values(getCiljeviData.entities || {}));

      setSpecCiljevi(Object.values(getSpecCiljeviData.entities || {}));

      // data objekat je dobar response message
      // const successMessage = getSpecCiljeviData?.message
    }

    if (isErrorGetSpecCiljevi) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getSpecCiljeviError?.data?.message;
      alert(errorMessage);
    }
  }, [
    isSuccessGetSpecCiljevi,
    isErrorGetSpecCiljevi,
    getSpecCiljeviError,
    getSpecCiljeviData,
  ]);

  //Add spec cilj
  useEffect(() => {
    if (isSuccessAddSpecCilj) {
      alert(dataAddSpecCilj.message.toString());
      // setSpecCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorAddSpecCilj) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorAddSpecCilj?.data?.message);
    }
  }, [
    isSuccessAddSpecCilj,
    isErrorAddSpecCilj,
    errorAddSpecCilj,
    dataAddSpecCilj,
  ]);

  //Update spec cilj
  useEffect(() => {
    if (isSuccessUpdateSpecCilj) {
      alert(dataUpdateSpecCilj.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorUpdateSpecCilj) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorUpdateSpecCilj?.data?.message);
    }
  }, [
    isSuccessUpdateSpecCilj,
    isErrorUpdateSpecCilj,
    errorUpdateSpecCilj,
    dataUpdateSpecCilj,
  ]);

  //Del spec cilj
  useEffect(() => {
    if (isSuccessDelSpecCilj) {
      alert(dataDelSpecCilj);
      // console.log('delleted', dataDelCilj)
    }

    if (isErrorDelSpecCilj) {
      alert(errorDelSpecCilj?.data?.message);
    }
  }, [
    isSuccessDelSpecCilj,
    isErrorDelSpecCilj,
    errorDelSpecCilj,
    dataDelSpecCilj,
  ]);

  //Get fizicke aktivnosti
  useEffect(() => {
    if (isSuccessGetFizAkt) {
      // console.log("Success response:", Object.values(getFizAktData.entities || {}));

      setFizAktinosti(Object.values(getFizAktData.entities || {}));

      // data objekat je dobar response message
      // const successMessage = getCiljeviData?.message
    }

    if (isErrorGetFizAkt) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getFizAktError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetFizAkt, isErrorGetFizAkt, getFizAktError, getFizAktData]);

  //Add fizicke aktivnosti
  useEffect(() => {
    if (isSuccessAddFizAkt) {
      alert(dataAddFizAkt.message.toString());
      setFizAktNaziv("");
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorAddFizAkt) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorAddFizAkt?.data?.message);
    }
  }, [isSuccessAddFizAkt, isErrorAddFizAkt, errorAddFizAkt, dataAddFizAkt]);

  //Update fiz akt
  useEffect(() => {
    if (isSuccessUpdateFizAkt) {
      alert(dataUpdateFizAkt.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorUpdateFizAkt) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorUpdateFizAkt?.data?.message);
    }
  }, [
    isSuccessUpdateFizAkt,
    isErrorUpdateFizAkt,
    errorUpdateFizAkt,
    dataUpdateFizAkt,
  ]);

  //Del fizicke aktivnosti
  useEffect(() => {
    if (isSuccessDelFizAkt) {
      alert(dataDelFizAkt);
      // console.log('delleted', dataDelCilj)
    }

    if (isErrorDelFizAkt) {
      alert(errorDelFizAkt?.data?.message);
    }
  }, [isSuccessDelFizAkt, isErrorDelFizAkt, errorDelFizAkt, dataDelFizAkt]);

  //Get dijagnozu
  useEffect(() => {
    if (isSuccessGetDijagnoza) {
      // console.log("Success response:", Object.values(getDijagnozaData.entities || {}));

      setDijagnoze(Object.values(getDijagnozaData.entities || {}));

      // data objekat je dobar response message
      // const successMessage = getCiljeviData?.message
    }

    if (isErrorGetDijagnoza) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getDijagnozaError?.data?.message;
      alert(errorMessage);
    }
  }, [
    isSuccessGetDijagnoza,
    isErrorGetDijagnoza,
    getDijagnozaError,
    getDijagnozaData,
  ]);

  //Add dijagnoz
  useEffect(() => {
    if (isSuccessAddDijagnoza) {
      alert(dataAddDijagnoza.message.toString());
      setDijagnozaNaziv(""); //???
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorAddDijagnoza) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorAddDijagnoza?.data?.message);
    }
  }, [
    isSuccessAddDijagnoza,
    isErrorAddDijagnoza,
    errorAddDijagnoza,
    dataAddDijagnoza,
  ]);

  //Update spec cilj
  useEffect(() => {
    if (isSuccessUpdateDijagnoza) {
      alert(dataUpdateDijagnoza.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorUpdateDijagnoza) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorUpdateDijagnoza?.data?.message);
    }
  }, [
    isSuccessUpdateDijagnoza,
    isErrorUpdateDijagnoza,
    errorUpdateDijagnoza,
    dataUpdateDijagnoza,
  ]);

  //Del dijagnoz
  useEffect(() => {
    if (isSuccessDelDijagnoza) {
      alert(dataDelDijagnoza);
      // console.log('delleted', dataDelCilj)
    }

    if (isErrorDelDijagnoza) {
      alert(errorDelDijagnoza?.data?.message);
    }
  }, [
    isSuccessDelDijagnoza,
    isErrorDelDijagnoza,
    errorDelDijagnoza,
    dataDelDijagnoza,
  ]);

  //Get motiv
  useEffect(() => {
    if (isSuccessGetMotiv) {
      // console.log("Success response:", Object.values(getDijagnozaData.entities || {}));

      setMotivi(Object.values(getMotivData.entities || {}));

      // data objekat je dobar response message
      // const successMessage = getCiljeviData?.message
    }

    if (isErrorGetMotiv) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getMotivError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetMotiv, isErrorGetMotiv, getMotivError, getMotivData]);

  //Add motiv
  useEffect(() => {
    if (isSuccessAddMotiv) {
      alert(dataAddMotiv.message.toString());
      setMotivNaziv("");
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorAddMotiv) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorAddMotiv?.data?.message);
    }
  }, [isSuccessAddMotiv, isErrorAddMotiv, errorAddMotiv, dataAddMotiv]);

  //Update motiv
  useEffect(() => {
    if (isSuccessUpdateMotiv) {
      alert(dataUpdateMotiv.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorUpdateMotiv) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorUpdateMotiv?.data?.message);
    }
  }, [
    isSuccessUpdateMotiv,
    isErrorUpdateMotiv,
    errorUpdateMotiv,
    dataUpdateMotiv,
  ]);

  //Del motiv
  useEffect(() => {
    if (isSuccessDelMotiv) {
      alert(dataDelMotiv);
      // console.log('delleted', dataDelCilj)
    }

    if (isErrorDelMotiv) {
      alert(errorDelMotiv?.data?.message);
    }
  }, [isSuccessDelMotiv, isErrorDelMotiv, errorDelMotiv, dataDelMotiv]);

  //Get ishrana
  // useEffect(() => {
  //   if (isSuccessGetIshrana) {
  //     // console.log("Success response:", Object.values(getCiljeviData.entities || {}));

  //     setIshrana(Object.values(getIshranaData.entities || {}))

  //     // data objekat je dobar response message
  //     // const successMessage = getCiljeviData?.message
  //   }

  //   if (isErrorGetIshrana) {
  //     // console.log("Error object:", error);

  //     // error objekat je kada nam posalje error poruke
  //     const errorMessage = getIshranaError?.data?.message
  //     alert(errorMessage);
  //   }
  // }, [isSuccessGetIshrana, isErrorGetIshrana, getIshranaError, getIshranaData]);

  //Add ishrana
  useEffect(() => {
    if (isSuccessAddIshrana) {
      alert(dataAddIshrana.message.toString());
      setIshranaNaziv("");
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorAddIshrana) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorAddIshrana?.data?.message);
    }
  }, [isSuccessAddIshrana, isErrorAddIshrana, errorAddIshrana, dataAddIshrana]);

  //Get chatKonv here
  useEffect(() => {
    if (isSuccessGetChatKonv) {
      // console.log("Success response:", Object.values(getDijagnozaData.entities || {}));

      setSviChetovi(Object.values(getChatKonvData.entities || {}));

      // data objekat je dobar response message
      // const successMessage = getCiljeviData?.message
    }

    if (isErrorGetChatKonv) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getChatKonvError?.data?.message;
      alert(errorMessage);
    }
  }, [
    isSuccessGetChatKonv,
    isErrorGetChatKonv,
    getChatKonvError,
    getMotivData,
  ]);

  //Del ChatKonv
  useEffect(() => {
    if (isSuccessDelChatKonv) {
      alert(dataDelChatKonv);
    }

    if (isErrorDelChatKonv) {
      alert(errorDelChatKonv?.data?.message);
    }
  }, [
    isSuccessDelChatKonv,
    isErrorDelChatKonv,
    errorDelChatKonv,
    dataDelChatKonv,
  ]);

  //Brise prim cilj
  const handleDelPrimCilj = async (id) => {
    try {
      await delCilj({ id });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  //Dodaje prim cilj
  const handleAddPrimCilj = async (e) => {
    e.preventDefault();

    if (!primCiljNaziv) {
      alert("Molimo Vas unesite naziv cilja.");
      return;
    }

    try {
      await addCilj({ tip: "primaranCilj", naziv: primCiljNaziv });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  //Dodaje kod
  const handleAddKod = async (e) => {
    e.preventDefault();

    if (!kodNaziv || !opisKod) {
      alert("Molimo Vas unesite naziv i opis cilja.");
      return;
    }

    try {
      await addkod({ naziv: kodNaziv, opis: opisKod });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  //Brise spec cilj - asajnuj
  const handleDelKod = async (id) => {
    try {
      await delKod({ id });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  //Brise spec cilj - asajnuj
  const handleDelSpecCilj = async (id) => {
    try {
      await delSpecCilj({ id });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  //Dodaje spec cilj - ima dole
  // const handleAddSpecCilj = async (e) => {
  //   e.preventDefault();

  //   if (!specCiljNaziv) {
  //     alert("Molimo Vas unesite naziv specificnog cilja.");
  //     return;
  //   }

  //   try {
  //     await addSpecCilj({ tip: "specCilj", naziv: specCiljNaziv });
  //   } catch (err) {
  //     console.error("Error occurred:", err);
  //   }
  // };

  //Brise fiz akt
  const handleDelFizAktivnost = async (id) => {
    try {
      await delFizAkt({ id });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  //Dodaje fiz akt
  const handleAddFizAktivnost = async (e) => {
    e.preventDefault();

    if (!fizAktNaziv) {
      alert("Molimo Vas unesite naziv fizicke aktivnosti.");
      return;
    }

    try {
      await addFizAkt({ tip: "fizickaAkt", naziv: fizAktNaziv });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  //Brise Dijagnozu
  const handleDelDijagnoza = async (id) => {
    try {
      await delDijagnoza({ id });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  //Dodaje dijagnozu
  const handleAddDijagnoza = async (e) => {
    e.preventDefault();

    if (!dijagnozaNaziv) {
      alert("Molimo Vas unesite naziv dijagnozu.");
      return;
    }

    try {
      await addDijagnoza({ tip: "dijagnoza", naziv: dijagnozaNaziv });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  //Brise motiv
  const handleDelMotiv = async (id) => {
    try {
      await delMotiv({ id });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  //Dodaje motiv
  const handleAddMotiv = async (e) => {
    e.preventDefault();

    if (!motivNaziv) {
      alert("Molimo Vas unesite naziv motiva.");
      return;
    }

    try {
      await addMotiv({ tip: "motiv", naziv: motivNaziv });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  //Dodaje Ishranu
  const handleAddIshrana = async (e) => {
    e.preventDefault();

    if (!ishranaNaziv) {
      alert("Molimo Vas unesite naziv Ishrane.");
      return;
    }

    try {
      await addIshrana({ tip: "primaranCilj", naziv: primCiljNaziv });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  //Brise chat
  const handleDelChat = async (id) => {
    try {
      await delChatKonv({ id });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  const onPrimCiljChanged = (e) => setPrimCiljNaziv(e.target.value);
  // const onSpecCiljChanged = (e) => setSpecCiljNaziv(e.target.value);
  const onFizAktChanged = (e) => setFizAktNaziv(e.target.value);
  const onDijagnozaChanged = (e) => setDijagnozaNaziv(e.target.value);
  const onMotivChanged = (e) => setMotivNaziv(e.target.value);
  const onNazivKodnaPromenjen = (e) => setKodNaziv(e.target.value);
  const onopiskodaPromenjen = (e) => setOpisKod(e.target.value);

  //Za primaran cilj UPDATE I MODAL
  const openEditModalPrimCilj = (job) => {
    setSelectedJobPrimCilj(job);
    setIsEditModalOpenPrimCilj(true);
    setInputValuePrimCilj(job.naziv);
  };

  const closeEditModalPrimCilj = () => {
    setIsEditModalOpenPrimCilj(false);
    setInputValuePrimCilj("");
    setSelectedJobPrimCilj(null);
  };

  const handleInputChange = (e) => {
    setInputValuePrimCilj(e.target.value);
  };

  //Ovde da saljemo request da se promeni/updatuje odrednjeni primaran cilj
  const handleConfirmEditPrimCilj = async () => {
    // console.log('Data for sending is: ', selectedJobPrimCilj._id + " <=> " + inputValuePrimCilj);

    if (!inputValuePrimCilj) {
      alert("Molimo Vas unesite nov naziv cilja.");
      return;
    }

    try {
      await updateCilj({
        id: selectedJobPrimCilj._id,
        naziv: inputValuePrimCilj,
      });
    } catch (err) {
      console.error("Error occurred:", err);
    }

    closeEditModalPrimCilj();
  };

  //Za specifican cilj UPDATE I MODAL
  const openEditModalSpecCilj = (job) => {
    setSelectedJobSpecCilj(job);
    setInputValueSpecCilj(job.naziv); // Set input value to current job name
    setIsEditModalOpenSpecCilj(true);
  };

  const closeEditModalSpecCilj = () => {
    setIsEditModalOpenSpecCilj(false);
    setInputValueSpecCilj("");
    setSelectedJobSpecCilj(null);
  };

  const handleInputChangeSpecCilj = (e) => {
    setInputValueSpecCilj(e.target.value);
  };

  const handleConfirmEditSpecCilj = async () => {
    if (selectedJobSpecCilj) {
      // console.log(selectedJobSpecCilj._id, inputValueSpecCilj);

      if (!inputValueSpecCilj) {
        alert("Molimo Vas unesite nov naziv cilja.");
        return;
      }

      try {
        await updateSpecCilj({
          id: selectedJobSpecCilj._id,
          naziv: inputValueSpecCilj,
        });
      } catch (err) {
        console.error("Error occurred:", err);
      }
    }
    closeEditModalSpecCilj();
  };

  //Za motiv UPDATE I MODAL
  const openEditModalMotiv = (job) => {
    setSelectedJobMotiv(job);
    setInputValueMotiv(job.naziv);
    setIsEditModalOpenMotiv(true);
  };

  const closeEditModalMotiv = () => {
    setIsEditModalOpenMotiv(false);
    setInputValueMotiv("");
    setSelectedJobMotiv(null);
  };

  const handleInputChangeMotiv = (e) => {
    setInputValueMotiv(e.target.value);
  };

  const handleConfirmEditMotiv = async () => {
    if (selectedJobMotiv) {
      // (selectedJobMotiv._id, inputValueMotiv);

      if (!inputValueMotiv) {
        alert("Molimo Vas unesite nov naziv motiva.");
        return;
      }

      try {
        await updateMotiv({ id: selectedJobMotiv._id, naziv: inputValueMotiv });
      } catch (err) {
        console.error("Error occurred:", err);
      }
    }
    closeEditModalMotiv();
  };

  //Za fiz akt UPDATE I MODAL
  const openEditModalFizAkt = (job) => {
    setSelectedJobFizAkt(job);
    setInputValueFizAkt(job.naziv); // Set input value to current job name
    setIsEditModalOpenFizAkt(true);
  };

  const closeEditModalFizAkt = () => {
    setIsEditModalOpenFizAkt(false);
    setInputValueFizAkt("");
    setSelectedJobFizAkt(null);
  };

  const handleInputChangeFizAkt = (e) => {
    setInputValueFizAkt(e.target.value);
  };

  const handleConfirmEditFizAkt = async () => {
    if (selectedJobFizAkt) {
      updateFizAkt(selectedJobFizAkt._id, inputValueFizAkt);

      if (!inputValueFizAkt) {
        alert("Molimo Vas unesite nov naziv fizicke aktivnosti.");
        return;
      }

      try {
        await updateFizAkt({
          id: selectedJobFizAkt._id,
          naziv: inputValueFizAkt,
        });
      } catch (err) {
        console.error("Error occurred:", err);
      }
    }
    closeEditModalFizAkt();
  };

  //Za dijagnozu UPDATE I MODAL
  const openEditModalDijagnoza = (job) => {
    setSelectedJobDijagnoza(job);
    setInputValueDijagnoza(job.naziv); // Set input value to current job name
    setIsEditModalOpenDijagnoza(true);
  };

  const closeEditModalDijagnoza = () => {
    setIsEditModalOpenDijagnoza(false);
    setInputValueDijagnoza("");
    setSelectedJobDijagnoza(null);
  };

  const handleInputChangeDijagnoza = (e) => {
    setInputValueDijagnoza(e.target.value);
  };

  const handleConfirmEditDijagnoza = async () => {
    if (selectedJobDijagnoza) {
      if (!inputValueDijagnoza) {
        alert("Molimo Vas unesite nov naziv dijagnoze.");
        return;
      }

      try {
        await updateDijagnoza({
          id: selectedJobDijagnoza._id,
          naziv: inputValueDijagnoza,
        });
      } catch (err) {
        console.error("Error occurred:", err);
      }
    }
    closeEditModalDijagnoza();
  };

  //Za tabove
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const handleTabClick = (tabName) => {
    setCurrentTab(tabName);
  };

  const handleSubTabClick = (subTabName) => {
    setCurrentSubTab(subTabName);
  };

  const handleSelectChange = (e) => {
    setCurrentTab(e.target.value);
  };

  const handleSubTabSelectChange = (e) => {
    setCurrentSubTab(e.target.value);
  };

  const handleSubTabSelectChangeParams = (e) => {
    setCurrentSubTabParams(e.target.value);
  };

  const handleSubTabSelectChangeDiet = (e) => {
    setCurrentSubTabDiet(e.target.value);
  };

  const handleSubTabClickParams = (subTabName) => {
    setCurrentSubTabParams(subTabName);
  };

  const handleSubTabClickDiet = (subTabName) => {
    setCurrentSubTabDiet(subTabName);
  };

  const handleSubTabClickPrompt = (subTabName) => {
    setCurrentSubTabPrompt(subTabName);
  };

  const handleSubTabSelectChangePrompt = (e) => {
    setCurrentSubTabPrompt(e.target.value);
  };

  const handleSubTabSelectChangeChatConv = (e) => {
    setCurrentSubTabChetConv(e);
  };

  const tabs = [
    { name: "Ciljevi" },
    { name: "Fizički parametri" },
    { name: "Ishrana i životne namirnice" },
    { name: "Namirnice" },
    { name: "Promptovi" },
    { name: "Čet konverzcija" },
    { name: "Kodovi" },
  ];

  const subTabsCiljevi = [
    { name: "Primarni cilj ishrane" },
    { name: "Specifični ciljevi" },
    { name: "Motivacija za promenu" },
  ];

  const subTabsFizicki = [
    { name: "Vrsta fizičke aktivnosti" },
    { name: "Postojeće zdravstvene dijagnoze" },
  ];

  const subTabsIshrana = [
    // { name: 'Tipovi ishrane' },
    { name: "Kreiraj ishranu" },
    // { name: 'Alergije (alergeni) na hranu' },
  ];

  const subTabsKodovi = [
    // { name: 'Tipovi ishrane' },
    { name: "Svi kodovi" },
    // { name: 'Alergije (alergeni) na hranu' },
  ];

  const subTabsChat = [{ name: "Pregled" }];

  const subTabsPromptovi = [
    { name: "Uvod" },
    { name: "Holistički pristup" },
    { name: "Plan ishrane" },
    { name: "Dani" },
    { name: "Smernice" },
    { name: "Fizička aktivnost" },
    { name: "Imunitet" },
    { name: "San" },
    { name: "Unos vode" },
    { name: "Prethodna isk. dijeta" },
    { name: "Alergije i intolerancije" },
    { name: "Alkohol" },
    { name: "Pušenje" },
    { name: "Zakljucak" },
  ];

  let kreirajIsh = () => {
    return null;
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  let tabovi = (
    <div className="bg-white shadow-sm ring-2 ring-gray-900/5 sm:rounded mt-3">
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded border-gray-300 focus:border-blue-500 focus:ring-blue-500"
          value={currentTab}
          onChange={handleSelectChange}
        >
          {tabs.map((tab) => (
            <option key={tab.name} value={tab.name}>
              {tab.name}
            </option>
          ))}
        </select>
      </div>

      <div className="hidden sm:block">
        <nav
          className="isolate flex divide-x divide-gray-200 rounded shadow"
          aria-label="Tabs"
        >
          {tabs.map((tab, tabIdx) => (
            <a
              key={tab.name}
              href={tab.href}
              onClick={(e) => {
                e.preventDefault();
                handleTabClick(tab.name);
              }}
              className={classNames(
                tab.name === currentTab
                  ? "text-gray-900"
                  : "text-gray-500 hover:text-gray-700",
                tabIdx === 0 ? "rounded-tl rounded-bl" : "",
                tabIdx === tabs.length - 1 ? "rounded-tr rounded-br" : "",
                "group relative w-1/2 overflow-hidden bg-white px-4 py-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
              )}
              aria-current={tab.name === currentTab ? "page" : undefined}
            >
              <span>{tab.name}</span>
              <span
                aria-hidden="true"
                className={classNames(
                  tab.name === currentTab ? "bg-blue-500" : "bg-transparent",
                  "absolute inset-x-0 bottom-0 h-0.5"
                )}
              />
            </a>
          ))}
        </nav>
      </div>

      <div className="">
        {currentTab === "Ciljevi" && (
          <div className="block w-full h-100 rounded bg-white p-2 border-gray-300">
            {/* Sub-tabs for "Ciljevi" */}
            <div className="sm:hidden">
              <label htmlFor="sub-tabs" className="sr-only">
                Select a sub-tab
              </label>
              <select
                id="sub-tabs"
                name="sub-tabs"
                className="block w-full rounded border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                value={currentSubTab}
                onChange={handleSubTabSelectChange}
              >
                {subTabsCiljevi.map((subTab) => (
                  <option key={subTab.name} value={subTab.name}>
                    {subTab.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="hidden sm:block">
              <nav
                className="isolate flex divide-x divide-gray-200 rounded shadow"
                aria-label="Sub-tabs"
              >
                {subTabsCiljevi.map((subTab, subTabIdx) => (
                  <a
                    key={subTab.name}
                    href={subTab.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubTabClick(subTab.name);
                    }}
                    className={classNames(
                      subTab.name === currentSubTab
                        ? "text-gray-900"
                        : "text-gray-500 hover:text-gray-700",
                      subTabIdx === 0 ? "rounded-tl rounded-bl" : "",
                      subTabIdx === subTabsCiljevi.length - 1
                        ? "rounded-tr rounded-br"
                        : "",
                      "group relative w-1/2 overflow-hidden bg-white px-4 py-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
                    )}
                    aria-current={
                      subTab.name === currentSubTab ? "page" : undefined
                    }
                  >
                    <span>{subTab.name}</span>
                    <span
                      aria-hidden="true"
                      className={classNames(
                        subTab.name === currentSubTab
                          ? "bg-blue-500"
                          : "bg-transparent",
                        "absolute inset-x-0 bottom-0 h-0.5"
                      )}
                    />
                  </a>
                ))}
              </nav>
            </div>

            {/* Sub-tab Ciljevi */}
            <div className="color">
              {currentSubTab === "Primarni cilj ishrane" && (
                <div className="block w-full h-100 bg-gray-100 p-2">
                  <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                    <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                      <div className="ml-4 mt-2">
                        <div className="flex items-center space-x-2">
                          <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                            Unesi primaran cilj:
                          </h3>
                          <input
                            id="primcilj"
                            value={primCiljNaziv}
                            onChange={onPrimCiljChanged}
                            name="primcilj"
                            type="text"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                          />
                        </div>
                      </div>
                      <div className="ml-4 mt-2 flex-shrink-0">
                        <button
                          type="button"
                          onClick={handleAddPrimCilj}
                          className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                        >
                          Dodaj
                        </button>
                      </div>
                    </div>

                    <ul className="mt-4">
                      {/* {primCiljevi?.map((job) => (
                        <li key={job._id} className="flex justify-between items-center border-b border-gray-200 py-3">
                          <span className="text-md font-semibold text-gray-900">
                            {job.naziv}
                          </span>
                          <button
                            onClick={() => handleDelPrimCilj(job._id)}
                            className="ml-4 text-red-600 hover:text-red-500"
                          >
                            Ukloni
                          </button>
                        </li>
                      ))} */}
                      {primCiljevi
                        .slice()
                        .reverse()
                        .map((job) => (
                          <li
                            key={job._id}
                            className="flex justify-between items-center border-b border-gray-200 py-3"
                          >
                            <span className="text-md font-semibold text-gray-900">
                              {job.naziv}
                            </span>
                            <div className="flex items-center">
                              <button
                                onClick={() => openEditModalPrimCilj(job)}
                                className="ml-4 text-blue-600 hover:text-blue-500"
                              >
                                Izmeni
                              </button>
                              <button
                                onClick={() => handleDelPrimCilj(job._id)}
                                className="ml-4 text-red-600 hover:text-red-500"
                              >
                                Ukloni
                              </button>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>

                  {isEditModalOpenPrimCilj && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto">
                      <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-md mx-4">
                        <button
                          onClick={closeEditModalPrimCilj}
                          className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 focus:outline-none text-2xl"
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          &times;
                        </button>
                        <h2 className="text-lg font-semibold mb-4 text-center">
                          Unesite nov naziv cilja
                        </h2>
                        <div className="flex items-center mb-4">
                          <input
                            id="inputField"
                            type="text"
                            value={inputValuePrimCilj}
                            onChange={handleInputChange}
                            className="border rounded px-2 py-1 w-full"
                            placeholder={`Trenutno: ${
                              selectedJobPrimCilj?.naziv || ""
                            }`}
                          />
                        </div>
                        <div className="flex justify-end">
                          <button
                            onClick={closeEditModalPrimCilj}
                            className="px-4 py-2 mr-1 bg-blue-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                          >
                            Ugasi
                          </button>
                          <button
                            onClick={handleConfirmEditPrimCilj}
                            className="px-4 py-2 ml-1 bg-red-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                          >
                            Izmeni
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {currentSubTab === "Specifični ciljevi" && <SpecCilj />}

              {isEditModalOpenSpecCilj && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto">
                  <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-md mx-4">
                    <button
                      onClick={closeEditModalSpecCilj}
                      className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 focus:outline-none text-2xl"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      &times;
                    </button>
                    <h2 className="text-lg font-semibold mb-4 text-center">
                      Unesite izmenu cilja
                    </h2>
                    <div className="flex items-center mb-4">
                      <input
                        id="inputField"
                        type="text"
                        value={inputValueSpecCilj}
                        onChange={handleInputChangeSpecCilj}
                        className="border rounded px-2 py-1 w-full"
                        placeholder={`Trenutno: ${
                          selectedJobSpecCilj?.naziv || ""
                        }`}
                      />
                    </div>
                    <div className="flex justify-end">
                      <button
                        onClick={closeEditModalSpecCilj}
                        className="px-4 py-2 mr-1 bg-blue-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                      >
                        Ugasi
                      </button>
                      <button
                        onClick={handleConfirmEditSpecCilj}
                        className="px-4 py-2 ml-1 bg-red-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                      >
                        Izmeni
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {currentSubTab === "Motivacija za promenu" && (
                <div className="block w-full h-100 bg-gray-100 p-2 border-black">
                  <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                    <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                      <div className="ml-4 mt-2">
                        <div className="flex items-center space-x-2">
                          <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                            Unesi motivaciju:
                          </h3>
                          <input
                            id="motiv"
                            value={motivNaziv}
                            onChange={onMotivChanged}
                            name="motiv"
                            type="text"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                          />
                        </div>
                      </div>
                      <div className="ml-4 mt-2 flex-shrink-0">
                        <button
                          type="button"
                          onClick={handleAddMotiv}
                          className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                        >
                          Dodaj
                        </button>
                      </div>
                    </div>

                    <ul className="mt-4">
                      {motivi
                        .slice()
                        .reverse()
                        .map((job) => (
                          <li
                            key={job._id}
                            className="flex justify-between items-center border-b border-gray-200 py-3"
                          >
                            <span className="text-md font-semibold text-gray-900">
                              {job.naziv}
                            </span>
                            <div className="flex items-center">
                              <button
                                onClick={() => openEditModalMotiv(job)}
                                className="ml-4 text-blue-600 hover:text-blue-500"
                              >
                                Izmeni
                              </button>
                              <button
                                onClick={() => handleDelMotiv(job._id)}
                                className="ml-4 text-red-600 hover:text-red-500"
                              >
                                Ukloni
                              </button>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {isEditModalOpenMotiv && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto">
            <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-md mx-4">
              <button
                onClick={closeEditModalMotiv}
                className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 focus:outline-none text-2xl"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                &times;
              </button>
              <h2 className="text-lg font-semibold mb-4 text-center">
                Unesite izmenu cilja
              </h2>
              <div className="flex items-center mb-4">
                <input
                  id="inputField"
                  type="text"
                  value={inputValueMotiv}
                  onChange={handleInputChangeMotiv}
                  className="border rounded px-2 py-1 w-full"
                  placeholder={`Trenutno: ${selectedJobMotiv?.naziv || ""}`}
                />
              </div>
              <div className="flex justify-end">
                <button
                  onClick={closeEditModalMotiv}
                  className="px-4 py-2 mr-1 bg-blue-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                >
                  Ugasi
                </button>
                <button
                  onClick={handleConfirmEditMotiv}
                  className="px-4 py-2 ml-1 bg-red-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                >
                  Izmeni
                </button>
              </div>
            </div>
          </div>
        )}

        {currentTab === "Fizički parametri" && (
          <div className="block w-full rounded bg-white p-2 border-gray-300">
            <div className="sm:hidden">
              <label htmlFor="sub-tabs-params" className="sr-only">
                Select a sub-tab
              </label>
              <select
                id="sub-tabs-params"
                name="sub-tabs-params"
                className="block w-full rounded border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                value={currentSubTabParams}
                onChange={handleSubTabSelectChangeParams}
              >
                {subTabsFizicki.map((subTab) => (
                  <option key={subTab.name} value={subTab.name}>
                    {subTab.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="hidden sm:block">
              <nav
                className="isolate flex divide-x divide-gray-200 rounded shadow"
                aria-label="Sub-tabs"
              >
                {subTabsFizicki.map((subTab, subTabIdx) => (
                  <a
                    key={subTab.name}
                    href={subTab.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubTabClickParams(subTab.name);
                    }}
                    className={classNames(
                      subTab.name === currentSubTabParams
                        ? "text-gray-900"
                        : "text-gray-500 hover:text-gray-700",
                      subTabIdx === 0 ? "rounded-tl rounded-bl" : "",
                      subTabIdx === subTabsFizicki.length - 1
                        ? "rounded-tr rounded-br"
                        : "",
                      "group relative w-1/2 overflow-hidden bg-white px-4 py-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
                    )}
                    aria-current={
                      subTab.name === currentSubTabParams ? "page" : undefined
                    }
                  >
                    <span>{subTab.name}</span>
                    <span
                      aria-hidden="true"
                      className={classNames(
                        subTab.name === currentSubTabParams
                          ? "bg-blue-500"
                          : "bg-transparent",
                        "absolute inset-x-0 bottom-0 h-0.5"
                      )}
                    />
                  </a>
                ))}
              </nav>
            </div>

            {/* Sub-tab Fizicki parametri */}
            <div className="color">
              {currentSubTabParams === "Vrsta fizičke aktivnosti" && (
                <div className="block w-full h-100 bg-gray-100 p-2">
                  <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                    <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                      <div className="ml-4 mt-2">
                        <div className="flex items-center space-x-2">
                          <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                            Unesi fizičku aktivnost:
                          </h3>
                          <input
                            id="fizakt"
                            value={fizAktNaziv}
                            onChange={onFizAktChanged}
                            name="fizakt"
                            type="text"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                          />
                        </div>
                      </div>
                      <div className="ml-4 mt-2 flex-shrink-0">
                        <button
                          type="button"
                          onClick={handleAddFizAktivnost}
                          className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                        >
                          Dodaj
                        </button>
                      </div>
                    </div>

                    <ul className="mt-4">
                      {fizAktinosti
                        .slice()
                        .reverse()
                        .map((job) => (
                          <li
                            key={job._id}
                            className="flex justify-between items-center border-b border-gray-200 py-3"
                          >
                            <span className="text-md font-semibold text-gray-900">
                              {job.naziv}
                            </span>
                            <div className="flex items-center">
                              <button
                                onClick={() => openEditModalFizAkt(job)}
                                className="ml-4 text-blue-600 hover:text-blue-500"
                              >
                                Izmeni
                              </button>
                              <button
                                onClick={() => handleDelFizAktivnost(job._id)}
                                className="ml-4 text-red-600 hover:text-red-500"
                              >
                                Ukloni
                              </button>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              )}

              {isEditModalOpenFizAkt && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto">
                  <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-md mx-4">
                    <button
                      onClick={closeEditModalFizAkt}
                      className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 focus:outline-none text-2xl"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      &times;
                    </button>
                    <h2 className="text-lg font-semibold mb-4 text-center">
                      Unesite izmenu fizičke aktivnosti
                    </h2>
                    <div className="flex items-center mb-4">
                      <input
                        id="inputField"
                        type="text"
                        value={inputValueFizAkt}
                        onChange={handleInputChangeFizAkt}
                        className="border rounded px-2 py-1 w-full"
                        placeholder={`Trenutno: ${
                          selectedJobFizAkt?.naziv || ""
                        }`}
                      />
                    </div>
                    <div className="flex justify-end">
                      <button
                        onClick={closeEditModalFizAkt}
                        className="px-4 py-2 mr-1 bg-blue-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                      >
                        Ugasi
                      </button>
                      <button
                        onClick={handleConfirmEditFizAkt}
                        className="px-4 py-2 ml-1 bg-red-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                      >
                        Izmeni
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {currentSubTabParams === "Postojeće zdravstvene dijagnoze" && (
                <div className="block w-full h-100 bg-gray-100 p-2 border-black">
                  <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                    <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                      <div className="ml-4 mt-2">
                        <div className="flex items-center space-x-2">
                          <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                            Unesi dijagnozu:
                          </h3>
                          <input
                            id="fizakt"
                            name="fizakt"
                            value={dijagnozaNaziv}
                            onChange={onDijagnozaChanged}
                            type="text"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                          />
                        </div>
                      </div>
                      <div className="ml-4 mt-2 flex-shrink-0">
                        <button
                          type="button"
                          onClick={handleAddDijagnoza}
                          className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                        >
                          Dodaj
                        </button>
                      </div>
                    </div>

                    <ul className="mt-4">
                      {dijagnoze
                        .slice()
                        .reverse()
                        .map((job) => (
                          <li
                            key={job._id}
                            className="flex justify-between items-center border-b border-gray-200 py-3"
                          >
                            <span className="text-md font-semibold text-gray-900">
                              {job.naziv}
                            </span>
                            <div className="flex items-center">
                              <button
                                onClick={() => openEditModalDijagnoza(job)}
                                className="ml-4 text-blue-600 hover:text-blue-500"
                              >
                                Izmeni
                              </button>
                              <button
                                onClick={() => handleDelDijagnoza(job._id)}
                                className="ml-4 text-red-600 hover:text-red-500"
                              >
                                Ukloni
                              </button>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {isEditModalOpenDijagnoza && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto">
            <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-md mx-4">
              <button
                onClick={closeEditModalDijagnoza}
                className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 focus:outline-none text-2xl"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                &times;
              </button>
              <h2 className="text-lg font-semibold mb-4 text-center">
                Unesite izmenu dijagnoze
              </h2>
              <div className="flex items-center mb-4">
                <input
                  id="inputField"
                  type="text"
                  value={inputValueDijagnoza}
                  onChange={handleInputChangeDijagnoza}
                  className="border rounded px-2 py-1 w-full"
                  placeholder={`Trenutno: ${selectedJobDijagnoza?.naziv || ""}`}
                />
              </div>
              <div className="flex justify-end">
                <button
                  onClick={closeEditModalDijagnoza}
                  className="px-4 py-2 mr-1 bg-blue-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                >
                  Ugasi
                </button>
                <button
                  onClick={handleConfirmEditDijagnoza}
                  className="px-4 py-2 ml-1 bg-red-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                >
                  Izmeni
                </button>
              </div>
            </div>
          </div>
        )}

        {currentTab === "Ishrana i životne namirnice" && (
          <div className="block w-full h-max rounded bg-white p-2 border-gray-300">
            <div className="sm:hidden">
              <label htmlFor="sub-tabs-diet" className="sr-only">
                Select a sub-tab
              </label>
              <select
                id="sub-tabs-diet"
                name="sub-tabs-diet"
                className="block w-full rounded border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                value={currentSubTabDiet}
                onChange={handleSubTabSelectChangeDiet}
              >
                {subTabsIshrana.map((subTab) => (
                  <option key={subTab.name} value={subTab.name}>
                    {subTab.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="hidden sm:block">
              <nav
                className="isolate flex divide-x divide-gray-200 rounded shadow"
                aria-label="Sub-tabs"
              >
                {subTabsIshrana.map((subTab, subTabIdx) => (
                  <a
                    key={subTab.name}
                    href={subTab.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubTabClickDiet(subTab.name);
                    }}
                    className={classNames(
                      subTab.name === currentSubTabDiet
                        ? "text-gray-900"
                        : "text-gray-500 hover:text-gray-700",
                      subTabIdx === 0 ? "rounded-tl rounded-bl" : "",
                      subTabIdx === subTabsIshrana.length - 1
                        ? "rounded-tr rounded-br"
                        : "",
                      "group relative w-1/2 overflow-hidden bg-white px-4 py-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
                    )}
                    aria-current={
                      subTab.name === currentSubTabDiet ? "page" : undefined
                    }
                  >
                    <span>{subTab.name}</span>
                    <span
                      aria-hidden="true"
                      className={classNames(
                        subTab.name === currentSubTabDiet
                          ? "bg-blue-500"
                          : "bg-transparent",
                        "absolute inset-x-0 bottom-0 h-0.5"
                      )}
                    />
                  </a>
                ))}
              </nav>
            </div>

            {/* Sub-tab Ishrana */}
            <div className="color">
              {/* {currentSubTabDiet === "Tipovi ishrane" && (
                <div className="block w-full h-100 P-2">
                
                  <div className="space-y-4">
                    <h3 className="text-md font-semibold text-gray-700">Definisi novi tip</h3>
                    <input
                      type="text"
                      value={newTipName}
                      onChange={(e) => setNewTipName(e.target.value)}
                      placeholder="Naziv novog tipa"
                      className="mt-1 p-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                    />
                    <button
                      onClick={handleAddTip}
                      className="mt-2 p-2 bg-blue-500 text-white rounded-lg shadow hover:bg-blue-600 transition"
                    >
                      Napravi tip
                    </button>
                  </div>

                  
                  <div className="space-y-4 mt-5">
                    <h3 className="text-md font-semibold text-gray-700">Izaberi tip gde ces definisati novi podtip</h3>
                    <select
                      onChange={(e) => {
                        setSelectedTipIndex(e.target.value);
                        setSelectedPodtipIndex('');
                      }}
                      value={selectedTipIndex || ''}
                      className="p-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                    >
                      <option value="">Izaberi tip</option>
                      {tips.map((tip, index) => (
                        <option key={index} value={index}>
                          {tip.ime}
                        </option>
                      ))}
                    </select>
                  </div>

             
                  <div className="space-y-4 mt-5">
                    <h3 className="text-md font-semibold text-gray-700">Definisi nov podtip za izabrani tip</h3>
                    <input
                      type="text"
                      value={newPodtipName}
                      onChange={(e) => setNewPodtipName(e.target.value)}
                      placeholder="Upisi naziv novog podtipa"
                      className="mt-1 p-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-green-400 focus:border-green-400"
                    />
                    <button
                      onClick={handleAddPodtip}
                      className="mt-2 p-2 bg-green-500 text-white rounded-lg shadow hover:bg-green-600 transition"
                      disabled={selectedTipIndex === ''}
                    >
                      Napravi podtip
                    </button>
                  </div>

                  <br/>
                  
                  
                  

                 
                 

                  

             

                </div>
              )} */}

              {currentSubTabDiet === "Kreiraj ishranu" && (
                <div className="block w-full h-100">
                  <IshranaForm />

                  {/* <div className="space-y-4 mt-6">
                    <div className="space-y-2">
                      <label className="block text-lg font-semibold text-gray-700">Naziv Ishrane</label>
                      <input
                        type="text"
                        value={nazivIshrane}
                        onChange={(e) => setNazivIshrane(e.target.value)}
                        placeholder="Naziv Ishrane"
                        className="mt-1 p-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                      />
                    </div>
                    <div className="space-y-2">
                      <label className="block text-lg font-semibold text-gray-700">Komentar Ishrane</label>
                      <textarea
                        value={komentarIshrane}
                        onChange={(e) => setKomentarIshrane(e.target.value)}
                        placeholder="Komentar Ishrane"
                        className="mt-1 p-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                      />
                    </div>
                  </div> */}

                  {/* <label
                    htmlFor="ishranaa"
                    className="block text-lg font-medium leading-6 text-gray-900 sm:pt-1.5">
                    Namirnice:
                  </label> */}

                  {/* <div className="space-y-4 mt-6"> */}
                  {/* <div className="space-y-4">
                        <h3 className="text-md font-semibold text-gray-700">Izaberi tip</h3>
                        <select
                          onChange={(e) => {
                            setSelectedTipIndex(e.target.value);
                            setSelectedPodtipIndex('');
                          }}
                          value={selectedTipIndex || ''}
                          className="mt-1 p-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                        >
                          <option value="">Izaberi tip</option>
                          {tips.map((tip, index) => (
                            <option key={index} value={index}>
                              {tip.ime}
                            </option>
                          ))}
                        </select>
                      </div> */}

                  {/* <div className="space-y-4">
                        <h3 className="text-md font-semibold text-gray-700">Izaberi podtip</h3>
                        {selectedTipIndex !== '' && tips[selectedTipIndex]?.podtipovi.length > 0 ? (
                          <select
                            onChange={(e) => setSelectedPodtipIndex(e.target.value)}
                            value={selectedPodtipIndex || ''}
                            className="mt-1 p-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-green-400 focus:border-green-400"
                          >
                            <option value="">Izaberi podtip</option>
                            {tips[selectedTipIndex]?.podtipovi.map((podtip, index) => (
                              <option key={index} value={index}>
                                {podtip.ime}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <p className="text-gray-500">Nema podtipa za selektovani tip.</p>
                        )}
                      </div> */}

                  {/* <button
                        onClick={() => setShowModal(true)}
                        className="p-2 bg-indigo-500 text-white rounded-lg shadow hover:bg-indigo-600 transition"
                        disabled={selectedTipIndex === '' || selectedPodtipIndex === ''}
                      >
                        Dodaj namirnice za podtip
                      </button> */}
                  {/* </div> */}

                  {/* {showModal && (
                      <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center">
                        <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg w-full">
                          <h3 className="text-lg font-semibold text-gray-700 mb-4">Izaberite namirnice za podtip</h3>
                          {availableNamirnice.length > 0 ? (
                            <table className="min-w-full table-auto">
                              <thead>
                                <tr>
                                  <th className="px-4 py-2">Izaberi</th>
                                  <th className="px-4 py-2">Ime Namirnice</th>
                                </tr>
                              </thead>
                              <tbody>
                                {availableNamirnice.map((namirnica, index) => (
                                  <tr key={index} className="bg-white border-b">
                                    <td className="px-4 py-2">
                                      <input
                                        type="checkbox"
                                        checked={selectedNamirnice.includes(namirnica)}
                                        onChange={() => handleSelectNamirnica(namirnica)}
                                        className="form-checkbox"
                                      />
                                    </td>
                                    <td className="px-4 py-2">{namirnica.ime}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <p className="text-gray-500">Nema definisanih namirnica.</p>
                          )}
                          <div className="mt-4 flex justify-between">
                            <button
                              onClick={() => setShowModal(false)}
                              className="p-2 bg-gray-500 text-white rounded-lg shadow hover:bg-gray-600 transition"
                            >
                              Zatvori
                            </button>
                            <button
                              onClick={handleAddNamirniceToPodtip}
                              className="p-2 bg-green-500 text-white rounded-lg shadow hover:bg-green-600 transition"
                              disabled={selectedNamirnice.length === 0}
                            >
                              Dodaj Namirnice
                            </button>
                          </div>
                        </div>
                      </div>
                    )} */}

                  {/* <div className="space-y-4 mt-6">
                      <h2 className="text-lg font-semibold text-gray-700">Prikaz</h2>
                      {tips.length > 0 ? (
                        tips.map((tip, tipIndex) => (
                          <div key={tipIndex} className="mb-4">
                            <h3 className="text-md font-semibold text-gray-900 flex justify-between">
                              {tip.ime}
                              <button
                                onClick={() => handleRemoveTip(tipIndex)}
                                className="text-red-500 hover:text-red-700"
                              >
                                Ukloni Tip
                              </button>
                            </h3>

                            {tip.podtipovi.length > 0 ? (
                              <div className="ml-4">
                                {tip.podtipovi.map((podtip, podtipIndex) => (
                                  <div key={podtipIndex}>
                                    <h5 className="text-md font-semibold text-gray-700 flex justify-between">
                                      {podtip.ime}
                                      <button
                                        onClick={() => handleRemovePodtip(podtipIndex)}
                                        className="text-red-500 hover:text-red-700"
                                      >
                                        Ukloni Podtip
                                      </button>
                                    </h5>
                                    <ul className="list-disc list-inside">
                                      {podtip.namirnice.length > 0 ? (
                                        podtip.namirnice.map((namirnica, idx) => (
                                          <li key={idx} className="flex items-center justify-between">
                                            <span>
                                              {namirnica.ime} (Gluten: {namirnica.Gluten ? 'Da' : 'Ne'}, Laktoza: {namirnica.Laktoza ? 'Da' : 'Ne'}, Alergen: {namirnica.Alergen ? 'Da' : 'Ne'})
                                            </span>
                                            <button
                                              onClick={() => handleRemoveNamirnica(namirnica, podtipIndex)}
                                              className="text-red-500 hover:text-red-700 ml-4"
                                            >
                                              Ukloni Namirnicu
                                            </button>
                                          </li>
                                        ))
                                      ) : (
                                        <li>Nema dodeljenih namirnica podtipu.</li>
                                      )}
                                    </ul>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <p className="text-gray-500">Nema podtipa za selektovani tip.</p>
                            )}
                          </div>
                        ))
                      ) : (
                        <p className="text-gray-600">Nema definisanih tipova.</p>
                      )}
                    </div> */}

                  {/* end */}
                </div>
              )}
              {/* {currentSubTabDiet === "Alergije (alergeni) na hranu" && (
                <div className="block w-full h-100 bg-gray-100 p-2 border-black">
                  <h2 className="text-xl font-semibold text-gray-900">Alergije (alergeni) na hranu</h2>
                  <p className="mt-2 text-gray-700">Alergije (alergeni) na hranu body</p>
                </div>
              )} */}
            </div>
          </div>
        )}

        {currentTab === "Namirnice" && (
          // <div className="block w-full h-80 rounded bg-white p-2 border-gray-300">

          //   <div className="space-y-4">
          //     <h3 className="text-md font-semibold text-gray-700">Definisi namirnicu</h3>
          //     <input
          //       type="text"
          //       value={newNamirnica.ime}
          //       onChange={(e) => setNewNamirnica({ ...newNamirnica, ime: e.target.value })}
          //       placeholder="Naziv nove namirnice"
          //       className="mt-1 p-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-purple-400 focus:border-purple-400"
          //     />
          //     <div className="flex items-center space-x-4">
          //       <label className="inline-flex items-center space-x-2">
          //         <input
          //           type="checkbox"
          //           checked={newNamirnica.Gluten}
          //           onChange={(e) => setNewNamirnica({ ...newNamirnica, Gluten: e.target.checked })}
          //           className="form-checkbox"
          //         />
          //         <span>Gluten</span>
          //       </label>
          //       <label className="inline-flex items-center space-x-2">
          //         <input
          //           type="checkbox"
          //           checked={newNamirnica.Laktoza}
          //           onChange={(e) => setNewNamirnica({ ...newNamirnica, Laktoza: e.target.checked })}
          //           className="form-checkbox"
          //         />
          //         <span>Laktoza</span>
          //       </label>
          //       <label className="inline-flex items-center space-x-2">
          //         <input
          //           type="checkbox"
          //           checked={newNamirnica.Alergen}
          //           onChange={(e) => setNewNamirnica({ ...newNamirnica, Alergen: e.target.checked })}
          //           className="form-checkbox"
          //         />
          //         <span>Alergen</span>
          //       </label>
          //     </div>

          //     {/* Select Ishrana for Namirnica */}
          //     <div className="space-y-4">
          //       {/* NE TREBA SELECT NEGO CHECKBOXOVI ISHRANE U KOJOJ SE NALAZI TA NAMIRNICA */}
          //       <h3 className="text-md font-semibold text-gray-700">Izaberi ishranu za namirnicu</h3>
          //       <select
          //         value={selectedIshrana}
          //         onChange={(e) => setSelectedIshrana(e.target.value)}
          //         className="mt-1 p-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
          //       >
          //         <option value="">Izaberi ishranu</option>
          //         {ishrane.map((ishrana, index) => (
          //           <option key={index} value={ishrana}>
          //             {ishrana}
          //           </option>
          //         ))}
          //       </select>
          //     </div>

          //     <button
          //       onClick={handleDefineNamirnica}
          //       className="mt-2 p-2 bg-purple-500 text-white rounded-lg shadow hover:bg-purple-600 transition"
          //     >
          //       Definisi namirnicu
          //     </button>
          //   </div>

          // </div>
          <NamirnicaForm />
        )}
      </div>
      {/* Za promptove */}
      {currentTab === "Promptovi" && (
        <div className="block w-full h-max rounded bg-white p-2 border-gray-300">
          <div className="sm:hidden">
            <label htmlFor="sub-tabs-prompt" className="sr-only">
              Select a sub-tab
            </label>
            <select
              id="sub-tabs-prompt"
              name="sub-tabs-prompt"
              className="block w-full rounded border-gray-300 focus:border-blue-500 focus:ring-blue-500"
              value={currentSubTabPrompt}
              onChange={handleSubTabSelectChangePrompt}
            >
              {subTabsPromptovi.map((subTab) => (
                <option key={subTab.name} value={subTab.name}>
                  {subTab.name}
                </option>
              ))}
            </select>
          </div>
          <div className="hidden sm:block">
            <nav
              className="isolate flex divide-x divide-gray-200 rounded shadow"
              aria-label="Sub-tabs"
            >
              {subTabsPromptovi.map((subTab, subTabIdx) => (
                <a
                  key={subTab.name}
                  href={subTab.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubTabClickPrompt(subTab.name);
                  }}
                  className={classNames(
                    subTab.name === currentSubTabPrompt
                      ? "text-gray-900"
                      : "text-gray-500 hover:text-gray-700",
                    subTabIdx === 0 ? "rounded-tl rounded-bl" : "",
                    subTabIdx === subTabsPromptovi.length - 1
                      ? "rounded-tr rounded-br"
                      : "",
                    "group relative w-1/2 overflow-hidden bg-white px-1 py-3 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
                  )}
                  aria-current={
                    subTab.name === currentSubTabPrompt ? "page" : undefined
                  }
                >
                  <span>{subTab.name}</span>
                  <span
                    aria-hidden="true"
                    className={classNames(
                      subTab.name === currentSubTabPrompt
                        ? "bg-blue-500"
                        : "bg-transparent",
                      "absolute inset-x-0 bottom-0 h-0.5"
                    )}
                  />
                </a>
              ))}
            </nav>
          </div>

          {/* Sub-tab promptovi */}
          <div className="color">
            {currentSubTabPrompt === "Uvod" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Podaci sadržani u predpromptu:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  {/* <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i prezime
                        korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Težina:</strong> [Težina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Primaran cilj:</strong> [Primarni cilj
                        korisnika]
                      </p>
                    </div>
  
                  </div> */}

                  {/* Stari */}
                  {/* <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti si veštačka inteligencija koja nudi uvod o planu
                      ishrane. Pružaj detaljna objašnjenja za
                      <span className="font-bold text-blue-500">
                        [Ime i prezime korisnika]
                      </span>
                      , sa godinama:
                      <span className="font-bold text-blue-500">
                        [Godine korisnika]
                      </span>
                      , visina:
                      <span className="font-bold text-blue-500">
                        [Visina korisnika]
                      </span>
                      , sa težinom:
                      <span className="font-bold text-blue-500">
                        [Težina korisnika]
                      </span>
                      , pol:
                      <span className="font-bold text-blue-500">
                        [Pol korisnika]
                      </span>
                      . Njegov/a primarni cilj ishrane je
                      <span className="font-bold text-blue-500">
                        [Primarni cilj korisnika]
                      </span>
                      .
                    </p>
                  </div> */}

                  {/* Novi */}
                  <div className="p-6 bg-gray-100 rounded-lg shadow-lg">
                    <p className="text-gray-700 mb-4">
                      Ti si najbolji nutricionista na svetu. Tvoj zadatak je da
                      napišeš personalizovani uvod za plan ishrane za korisnika
                      sa sledećim podacima:
                    </p>
                    <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Intolerancije:{" "}
                        <span className="font-semibold">[Gluten, laktoza]</span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                      <li>
                        Dijagnoza:{" "}
                        <span className="font-semibold">
                          [Zadravstvene dijagnoze]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                      <li>
                        Unos alkohola:{" "}
                        <span className="font-semibold">[Unos alkohola]</span>
                      </li>
                      <li>
                        Navika pušenja:{" "}
                        <span className="font-semibold">[Koliko cigareta]</span>
                      </li>
                    </ul>

                    {/* Prosla lista */}
                    {/* <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                    </ul> */}
                    <p className="text-gray-700 mb-4">
                      Tvoj zadatak je da na osnovu ovih podataka napišeš uvod
                      koji:
                    </p>
                    <ul className="list-decimal list-inside text-gray-600 mb-4">
                      <li>Personalizovano se obraća korisniku.</li>
                      <li>
                        Kratko analizira trenutno stanje korisnika i ističe
                        ključne informacije.
                      </li>
                      <li>
                        Motivacionim tonom ohrabruje korisnika za promenu.
                      </li>
                      <li>
                        Nagoveštava sledeći deo izveštaja (
                        <span className="italic">Holistički pristup</span>).
                      </li>
                    </ul>
                    <p className="text-gray-700 mb-4 font-medium">
                      Pravila za uvod:
                    </p>
                    <ol className="list-decimal list-inside text-gray-600 mb-4">
                      <li>
                        Izbegavaj formalne fraze poput{" "}
                        <span className="italic">Srdačno</span> ili{" "}
                        <span className="italic">S poštovanjem</span>.
                      </li>
                      <li>
                        Završetak uvoda treba da ostavlja pozitivan utisak i
                        prirodno vodi korisnika ka sledećem delu izveštaja.
                      </li>
                      <li>
                        Održavaj ton profesionalnim, empatičnim i motivišućim.
                      </li>
                      <li>
                        Izbegavaj preopterećenje podacima, fokusiraj se na
                        ključne tačke.
                      </li>
                    </ol>
                    <p className="text-gray-700">
                      Na kraju uvoda, koristi frazu poput:{" "}
                      <span className="italic">
                        U narednom delu istražićemo holistički pristup vašem
                        zdravlju i ishrani, povezujući fizičko i mentalno
                        blagostanje.
                      </span>
                    </p>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definiši podatke za prompt (Napravi mu da izgenerise
                          dva pasusa uvoda):
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        type="button"
                        onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Sačuvaj
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="uvod"
                    value={uvodPrompt}
                    onChange={updateUvodPrompt}
                    name="uvod"
                    rows="20"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                  {/* Input za broj tokena */}
                  <div className="mt-4 mb-2">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                      Definiši broj karaktera za odgovor:
                    </h3>
                  </div>

                  <div className="flex justify-between w-full items-center">
                    <input
                      type="number"
                      name="uvod"
                      id="uvod"
                      value={brKarUvod}
                      onChange={handleEditbrKarUvod}
                      className="w-32 rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      min="0"
                      max="9999" // Optional input constraint
                      placeholder="Unesite broj"
                    />
                    <div className="text-lg text-gray-600">
                      {uvodPrompt.length} karaktera
                    </div>
                  </div>
                </div>

                {/* end */}
              </div>
            )}

            {currentSubTabPrompt === "Dani" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definisani podatci za u predprompt:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i Prezime
                        Korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Težina:</strong> [Težina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Primaran cilj:</strong> [Primarni cilj
                        korisnika]
                      </p>
                    </div>
                  </div>

                  <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti si nutricionista specijalizovan za precizne planove
                      ishrane. Tvoja odgovornost je da generišeš plan ishrane u
                      JSON formatu koristeći samo zadatu šemu.
                      <br />
                      <span className="font-bold">Pravila:</span>
                      <br />
                      - Nemoj da raspodelis kalorijsku vrednost ravnomerno
                      između obroka.
                      <br />
                      - Koristi samo zadate namirnice i izbegavaj isključene
                      namirnice.
                      <br />
                      - Nazivi dana treba da budu 'Dan 1', 'Dan 2', itd., bez
                      imena dana u nedelji.
                      <br />- Za svaki obrok navedi tačnu kalorijsku vrednost.
                    </p>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definisani podatci za prompt:
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        // type="button"
                        // onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-white-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-white-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white-600"
                      ></button>
                    </div>
                  </div>

                  <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Napravi plan ishrane za tačno
                      <span className="font-bold text-blue-500">
                        [Broj dana]
                      </span>{" "}
                      dana sa sledećim obrocima:
                      <span className="font-bold text-blue-500">
                        [Dorucak rucak...]
                      </span>
                      .
                      <br />
                      <br />
                      <span className="font-bold">Primarni cilj:</span>
                      <span className="font-bold text-blue-500">
                        [Primarni cilj korisnika]
                      </span>
                      .
                      <br />
                      <br />
                      <span className="font-bold">
                        Ukupna kalorijska vrednost:
                      </span>
                      <span className="font-bold text-blue-500">
                        [Ukupna kalorijska vrednost]
                      </span>{" "}
                      kcal po danu.
                      <br />
                      <br />
                      <span className="font-bold">Preferirane namirnice:</span>
                      <span className="font-bold text-blue-500">
                        [Voljne namirnice]
                      </span>
                      .
                      <br />
                      <br />
                      <span className="font-bold">
                        Izbegavati sledeće namirnice:
                      </span>
                      <span className="font-bold text-blue-500">
                        [Ne voljne namirnice]
                      </span>
                      .
                      <br />
                      <br />
                      Cene moraju biti okvirne i izražene u RSD. Namirnice
                      trebaju da budu izražene u gramima. Napiši nutritivnu
                      vrednost u jednoj rečenici.
                      <br />
                      <br />
                      Svi obroci moraju imati precizne kalorijske vrednosti koje
                      doprinose ukupnom dnevnom unosu kalorija. Ne uključuj
                      obroke koji nisu navedeni.
                    </p>
                  </div>
                </div>

                {/* end */}
              </div>
            )}

            {currentSubTabPrompt === "Holistički pristup" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Podaci sadržani u predpromptu:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  {/* <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i prezime
                        korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Težina:</strong> [Težina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Primaran cilj:</strong> [Primarni cilj
                        korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Specifični Cilj:</strong> [Specifičan cilj
                        korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Motivacija:</strong> [Razlog zbog kojeg korisnik
                        želi promene]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Nivo Fizičke Aktivnosti:</strong> [Nivo]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Vrste Fizičke Aktivnosti:</strong> [Trčanje,
                        biciklizam, vežbanje u teretani, itd.]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Stanje Imuniteta:</strong> [Slab/Jak]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Vrste Ishrane:</strong> [Vegetarijanska, keto,
                        veganska, itd.]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Navike u Ishrani:</strong> [Obroci u pravilnim
                        intervalima, uživanje u slatkišima, itd.]
                      </p>
                    </div>
                  </div> */}

                  {/* Stari */}
                  {/* <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti si veštačka inteligencija koja nudi personalizovane
                      savete o zdravlju i dobrobiti zasnovane na holističkom
                      pristupu. Pružaj detaljna objašnjenja za
                      <span className="font-bold text-blue-500">
                        [Ime i prezime korisnika]
                      </span>
                      , sa godinama:
                      <span className="font-bold text-blue-500">
                        [Godine korisnika]
                      </span>
                      , visina:
                      <span className="font-bold text-blue-500">
                        [Visina korisnika]
                      </span>
                      , sa težinom:
                      <span className="font-bold text-blue-500">
                        [Težina korisnika]
                      </span>
                      , pol:
                      <span className="font-bold text-blue-500">
                        [Pol korisnika]
                      </span>
                      , sa primarnim ciljem:
                      <span className="font-bold text-blue-500">
                        [Primarni cilj korisnika]
                      </span>{" "}
                      i specifičnim ciljem:
                      <span className="font-bold text-blue-500">
                        [Specifičan cilj korisnika]
                      </span>
                      . Motivacija za promenu uključuje:
                      <span className="font-bold text-blue-500">
                        [Razlog zbog kojeg korisnik želi promene]
                      </span>
                      , nivo fizičke aktivnosti:
                      <span className="font-bold text-blue-500">[Nivo]</span>, vrsta
                      fizičke aktivnosti:
                      <span className="font-bold text-blue-500">
                        [Trčanje, biciklizam, vežbanje u teretani, itd.]
                      </span>
                      , i ishrana:
                      <span className="font-bold text-blue-500">
                        [Vegetarijanska, keto, veganska, itd.]
                      </span>
                      <span className="font-bold text-blue-500">
                        Sa stanjem imuniteta [Slab/Jak]
                      </span>
                      .
                    </p>
                  </div> */}

                  {/* Novi */}

                  <div className="p-6 bg-gray-50 rounded-lg shadow-md">
                    <p className="text-gray-700 mb-4">
                      Ti si najbolji nutricionista na svetu. Specijalizovan si
                      za personalizovane savete o zdravlju i dobrobiti zasnovane
                      na holističkom pristupu. Tvoj zadatak je da pišeš sekciju
                      izveštaja koja korisniku jasno objašnjava značaj
                      povezivanja ishrane, fizičke aktivnosti i mentalnog
                      zdravlja za postizanje dugoročnih rezultata. Koristi
                      sledeće personalizovane podatke o korisniku:
                    </p>
                    <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Intolerancije:{" "}
                        <span className="font-semibold">[Gluten, laktoza]</span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                      <li>
                        Dijagnoza:{" "}
                        <span className="font-semibold">
                          [Zadravstvene dijagnoze]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                      <li>
                        Unos alkohola:{" "}
                        <span className="font-semibold">[Unos alkohola]</span>
                      </li>
                      <li>
                        Navika pušenja:{" "}
                        <span className="font-semibold">[Koliko cigareta]</span>
                      </li>
                    </ul>

                    {/* Starta lista */}
                    {/* <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Razlog zbog kojeg korisnik želi promene]
                        </span>
                      </li>
                      <li>
                        Nivo fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                    </ul> */}
                    <p className="text-gray-700 mb-4">
                      Tvoj zadatak je da pišeš sekciju koja:
                    </p>
                    <ol className="list-decimal list-inside text-gray-600 mb-4">
                      <li>
                        Objašnjava značaj holističkog pristupa zdravlju,
                        uključujući povezanost fizičkog, mentalnog i nutritivnog
                        zdravlja.
                      </li>
                      <li>
                        Koristi podatke o korisniku da bi objasnila kako
                        personalizovan pristup doprinosi postizanju njihovih
                        ciljeva.
                      </li>
                      <li>
                        Prikazuje 2–3 jednostavne i praktične promene koje
                        korisnik može odmah primeniti, uz objašnjenje zašto su
                        važne.
                      </li>
                      <li>
                        Održava topao i motivišući ton, fokusirajući se na
                        održivost i dugoročne koristi.
                      </li>
                      <li>
                        Priprema korisnika za sledeću sekciju izveštaja,{" "}
                        <span className="italic">
                          ‘Personalizovani plan ishrane’
                        </span>
                        , uz tranzicionu frazu poput:{" "}
                        <span className="italic">
                          ‘Sada, kada razumete važnost holističkog pristupa,
                          prelazimo na detaljan plan ishrane prilagođen vašim
                          ciljevima.’
                        </span>
                      </li>
                    </ol>
                    <p className="text-gray-700 font-medium mb-4">Pravila:</p>
                    <ul className="list-disc list-inside text-gray-600">
                      <li>
                        Nemoj koristiti previše stručne termine – objašnjenja
                        moraju biti jasna i razumljiva.
                      </li>
                      <li>
                        Ton treba da bude profesionalan, ali pristupačan i
                        inspirativan.
                      </li>
                      <li>
                        Nemoj koristiti formalne fraze poput{" "}
                        <span className="italic">‘Srdačno’</span> ili{" "}
                        <span className="italic">‘S poštovanjem’</span>.
                      </li>
                      <li>
                        Fokusiraj se na motivisanje korisnika da započne primenu
                        saveta iz ove sekcije.
                      </li>
                    </ul>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definiši podatke za prompt:
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        type="button"
                        onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Sačuvaj
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="holPrompt"
                    value={holistickiPrompt}
                    onChange={updateHolistickiPrompt}
                    name="holPrompt"
                    rows="20"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                  {/* Input za broj tokena */}
                  <div className="mt-4 mb-2">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                      Definiši broj karaktera za odgovor:
                    </h3>
                  </div>

                  <div className="flex justify-between w-full items-center">
                    <input
                      type="number"
                      name="brojKarhol"
                      id="brojKarhol"
                      value={brKarHol}
                      onChange={handleEditbrKarHol}
                      className="block w-32 rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      min="0"
                      max="9999" // Opcionalno ograničenje unosa
                      placeholder="Unesite broj"
                    />
                    <div className="text-lg text-gray-600">
                      {holistickiPrompt.length} karaktera
                    </div>
                  </div>
                </div>

                {/* end */}
              </div>
            )}

            {currentSubTabPrompt === "Plan ishrane" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Podaci sadržani u predpromptu:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  {/* <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i Prezime
                        Korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Težina:</strong> [Težina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Primaran cilj:</strong> [Primarni cilj
                        korisnika]
                      </p>
                    </div>
                  </div> */}

                  {/* Old */}
                  {/* <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti si veštačka inteligencija koja nudi uvod o
                      personalizovanom planu ishrane, pružaj detaljno
                      objašnjenje za
                      <span className="font-bold text-blue-500">
                        [Ime i Prezime Korisnika]
                      </span>{" "}
                      sa godinama:
                      <span className="font-bold text-blue-500">
                        [Godine korisnika]
                      </span>
                      , visina:
                      <span className="font-bold text-blue-500">
                        [Visina korisnika]
                      </span>
                      , sa težinom:
                      <span className="font-bold text-blue-500">
                        [Težina korisnika]
                      </span>
                      , pol:
                      <span className="font-bold text-blue-500">
                        [Pol korisnika]
                      </span>
                      , sa primarnim ciljem:
                      <span className="font-bold text-blue-500">
                        [Primarni cilj korisnika]
                      </span>
                      .
                    </p>
                  </div> */}

                  {/* New */}

                  <div className="p-6 bg-gray-50 rounded-lg shadow-md">
                    <p className="text-gray-700 mb-4">
                      Ti si najbolji nutricionista na svetu. Specijalizovan si
                      za kreiranje personalizovanih planova ishrane prilagođenih
                      individualnim potrebama i ciljevima korisnika. Na osnovu
                      sledećih podataka o korisniku:
                    </p>
                    <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Intolerancije:{" "}
                        <span className="font-semibold">[Gluten, laktoza]</span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                      <li>
                        Dijagnoza:{" "}
                        <span className="font-semibold">
                          [Zadravstvene dijagnoze]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                      <li>
                        Unos alkohola:{" "}
                        <span className="font-semibold">[Unos alkohola]</span>
                      </li>
                      <li>
                        Navika pušenja:{" "}
                        <span className="font-semibold">[Koliko cigareta]</span>
                      </li>
                    </ul>

                    {/* Starta lista */}
                    {/* <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i Prezime Korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                    </ul> */}
                    <h2 className="text-xl font-bold text-gray-700 mb-4">
                      Personalizovani plan ishrane
                    </h2>
                    <div className="mb-6">
                      <h3 className="text-lg font-semibold text-gray-700 mb-2">
                        1. Ciljevi i principi plana
                      </h3>
                      <ul className="list-disc list-inside text-gray-600 mb-4">
                        <li>
                          Jasno definiši korisnikov primarni cilj i ključne
                          principe koji će mu pomoći da ga postigne.
                        </li>
                        <li>
                          Objasni kako će plan doprineti ostvarenju njegovih
                          ciljeva (npr. balansirana ishrana, unos
                          makronutrijenata).
                        </li>
                      </ul>
                    </div>
                    <div className="mb-6">
                      <h3 className="text-lg font-semibold text-gray-700 mb-2">
                        2. Lista dozvoljenih i izbegavanih namirnica
                      </h3>
                      <ul className="list-disc list-inside text-gray-600 mb-4">
                        <li>
                          Navedite konkretne namirnice koje su preporučene na
                          osnovu korisnikovih potreba i preferencija.
                        </li>
                        <li>
                          Napravite listu namirnica koje treba izbegavati zbog
                          alergija, zdravstvenih problema ili ciljeva.
                        </li>
                      </ul>
                    </div>
                    <div className="mb-6">
                      <h3 className="text-lg font-semibold text-gray-700 mb-2">
                        3. Nutritivne smernice
                      </h3>
                      <ul className="list-disc list-inside text-gray-600 mb-4">
                        <li>
                          Definiši ukupan dnevni kalorijski unos i preporučenu
                          raspodelu makronutrijenata (ugljeni hidrati, masti,
                          proteini).
                        </li>
                        <li>
                          Istakni važnost hidratacije i preporuči optimalni
                          dnevni unos vode.
                        </li>
                      </ul>
                    </div>
                    <div className="mb-6">
                      <h3 className="text-lg font-semibold text-gray-700 mb-2">
                        4. Praktične napomene o pripremi hrane
                      </h3>
                      <ul className="list-disc list-inside text-gray-600 mb-4">
                        <li>
                          Objasni metode pripreme koje su deo plana (pečenje,
                          kuvanje na pari, izbegavanje prženja).
                        </li>
                        <li>
                          Naglas važnost korišćenja svežih i neprerađenih
                          namirnica.
                        </li>
                      </ul>
                    </div>
                    <div className="mb-6">
                      <h3 className="text-lg font-semibold text-gray-700 mb-2">
                        5. Učestalost i struktura obroka
                      </h3>
                      <ul className="list-disc list-inside text-gray-700 mb-4">
                        <li>
                          Navedite preporučeni broj obroka dnevno (npr. tri
                          glavna obroka i dve užine).
                        </li>
                        <li>
                          Predložite optimalno vreme za obroke (npr. doručak do
                          9h, večera do 19h).
                        </li>
                      </ul>
                    </div>
                    <p className="text-gray-700">
                      Sada, kada razumete važnost personalizovanog plana
                      ishrane, prelazimo na detaljne savete koji će vam pomoći
                      da postignete svoje ciljeve.
                    </p>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definiši podatke za prompt:
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        type="button"
                        onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Sačuvaj
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="planish"
                    value={planIshranePrompt}
                    onChange={updatePlanIshranePrompt}
                    name="planish"
                    rows="20"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                  {/* Input za broj tokena */}
                  <div className="mt-4 mb-2">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                      Definiši broj karaktera za odgovor:
                    </h3>
                  </div>

                  <div className="flex justify-between w-full items-center">
                    <input
                      type="number"
                      name="brojKarhol"
                      id="brojKarhol"
                      value={planIshBrKar}
                      onChange={handleEditPlanIshBrKar}
                      className="block w-32 rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      min="0"
                      max="9999" // Opcionalno ograničenje unosa
                      placeholder="Unesite broj"
                    />
                    <div className="text-lg text-gray-600">
                      {planIshranePrompt.length} karaktera
                    </div>
                  </div>
                </div>

                {/* end */}
              </div>
            )}

            {currentSubTabPrompt === "Smernice" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Podaci sadržani u predpromptu:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  {/* <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i Prezime
                        Korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Težina:</strong> [Težina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>


                  </div> */}

                  <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti nudis najbolje smernice za ishranu. Pružaj detaljna
                      objašnjenja za
                      {/* <span className="font-bold text-blue-500">
                        [Ime i Prezime Korisnika]
                      </span>
                      , sa godinama:
                      <span className="font-bold text-blue-500">
                        [Godine korisnika]
                      </span>
                      , visina:
                      <span className="font-bold text-blue-500">
                        [Visina korisnika]
                      </span>
                      , sa težinom:
                      <span className="font-bold text-blue-500">
                        [Težina korisnika]
                      </span>
                      , pol:
                      <span className="font-bold text-blue-500">
                        [Pol korisnika]
                      </span> */}
                      :
                    </p>

                    <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Intolerancije:{" "}
                        <span className="font-semibold">[Gluten, laktoza]</span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                      <li>
                        Dijagnoza:{" "}
                        <span className="font-semibold">
                          [Zadravstvene dijagnoze]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                      <li>
                        Unos alkohola:{" "}
                        <span className="font-semibold">[Unos alkohola]</span>
                      </li>
                      <li>
                        Navika pušenja:{" "}
                        <span className="font-semibold">[Koliko cigareta]</span>
                      </li>
                    </ul>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definiši podatke za prompt:
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        type="button"
                        onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Sačuvaj
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="Smernice"
                    value={smernicePrompt}
                    onChange={updateSmernicePrompt}
                    name="Smernice"
                    rows="20"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                  {/* Input za broj tokena */}
                  <div className="mt-4 mb-2">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                      Definiši broj karaktera za odgovor:
                    </h3>
                  </div>

                  <div className="flex justify-between w-full items-center">
                    <input
                      type="number"
                      name="Smernice"
                      id="Smernice"
                      value={smerniceBrKar}
                      onChange={handleEditSmerniceBrKar}
                      className="block w-32 rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      min="0"
                      max="9999"
                      placeholder="Unesite broj"
                    />
                    <div className="text-lg text-gray-600">
                      {smernicePrompt.length} karaktera
                    </div>
                  </div>
                </div>

                {/* end */}
              </div>
            )}

            {currentSubTabPrompt === "Fizička aktivnost" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Podaci sadržani u predpromptu:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  {/* <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i Prezime
                        Korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Težina:</strong> [Težina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Primaran cilj:</strong> [Primarni cilj
                        korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Specifični Cilj:</strong> [Specifičan cilj
                        korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Dijagnoza:</strong> [Zadravstvene dijagnoze]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Trenutna težina:</strong> [Težina]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Obim struka:</strong> [Obim struka]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Motivacija:</strong> [Motivacija korisnika]
                      </p>
                    </div>
                  </div> */}

                  <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti najbolje nudis personalizovane planove fizičke
                      aktivnosti. Pružaj detaljna objašnjenja za
                      {/* <span className="font-bold text-blue-500">
                        [Ime i Prezime Korisnika]
                      </span>{" "}
                      sa godinama:
                      <span className="font-bold text-blue-500">
                        [Godine korisnika]
                      </span>
                      , visina:
                      <span className="font-bold text-blue-500">
                        [Visina korisnika]
                      </span>{" "}
                      cm, sa težinom:
                      <span className="font-bold text-blue-500">
                        [Težina korisnika]
                      </span>{" "}
                      kg, pol:
                      <span className="font-bold text-blue-500">
                        [Pol korisnika]
                      </span>{" "}
                      koji ima primaran cilj:
                      <span className="font-bold text-blue-500">
                        [Primarni cilj korisnika]
                      </span>
                      , a specifične ciljeve:
                      <span className="font-bold text-blue-500">
                        [Specifičan cilj korisnika]
                      </span>
                      , obim struka mu je:
                      <span className="font-bold text-blue-500">
                        [Obim struka]
                      </span>{" "}
                      cm. Motivacija za potrebu fizičkih aktivnosti uključuje:
                      <span className="font-bold text-blue-500">
                        [Motivacija korisnika]
                      </span>
                      . A ima dijagnozu:
                      <span className="font-bold text-blue-500">
                        [Zdravstvene dijagnoze]
                      </span> */}
                      :
                    </p>
                    <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Intolerancije:{" "}
                        <span className="font-semibold">[Gluten, laktoza]</span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                      <li>
                        Dijagnoza:{" "}
                        <span className="font-semibold">
                          [Zadravstvene dijagnoze]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                      <li>
                        Unos alkohola:{" "}
                        <span className="font-semibold">[Unos alkohola]</span>
                      </li>
                      <li>
                        Navika pušenja:{" "}
                        <span className="font-semibold">[Koliko cigareta]</span>
                      </li>
                    </ul>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definiši podatke za prompt:
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        type="button"
                        onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Sačuvaj
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="fiz"
                    value={fizickaAktivnostPrompt}
                    onChange={updateFizickaAktivnostPrompt}
                    name="fiz"
                    rows="20"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                  {/* Input za broj tokena */}
                  <div className="mt-4 mb-2">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                      Definiši broj karaktera za odgovor:
                    </h3>
                  </div>

                  <div className="flex justify-between w-full items-center">
                    <input
                      type="number"
                      name="brojKarhol"
                      id="brojKarhol"
                      value={fizAktBrKar}
                      onChange={handleEditFizAktBrKar}
                      className="block w-32 rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      min="0"
                      max="9999" // Opcionalno ograničenje unosa
                      placeholder="Unesite broj"
                    />
                    <div className="text-lg text-gray-600">
                      {fizickaAktivnostPrompt.length} karaktera
                    </div>
                  </div>
                </div>

                {/* end */}
              </div>
            )}

            {currentSubTabPrompt === "Imunitet" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Podaci sadržani u predpromptu:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  {/* <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i Prezime
                        Korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Težina:</strong> [Težina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Specifični Cilj:</strong> [Specifičan cilj
                        korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Motivacija:</strong> [Razlog zbog kojeg korisnik
                        želi promene]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Navike u ishrani:</strong> [Navike u ishrani]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Alergije:</strong> [Osip, svrab...]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Intolerancije:</strong> [Gluten, laktoza]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Stanje Imuniteta:</strong> [Slab/Jak]
                      </p>
                    </div>
                  </div> */}

                  <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti najbolje dajes izvestaje i preporuke za brigu o
                      imunitetu. Pružaj detaljno objašnjenje:
                      {/* <span className="font-bold text-blue-500">
                        [Ime i Prezime Korisnika]
                      </span>{" "}
                      sa godinama:
                      <span className="font-bold text-blue-500">
                        [Godine korisnika]
                      </span>
                      , visina:
                      <span className="font-bold text-blue-500">
                        [Visina korisnika]
                      </span>
                      , sa težinom:
                      <span className="font-bold text-blue-500">
                        [Težina korisnika]
                      </span>
                      , pol:
                      <span className="font-bold text-blue-500">
                        [Pol korisnika]
                      </span>{" "}
                      može poboljšati svoj imunitet, imajući u vidu da ima jak
                      imunitet i motivaciju za promenu:
                      <span className="font-bold text-blue-500">zdravlje</span>.
                      Njegovi specifični ciljevi su:
                      <span className="font-bold text-blue-500">
                        [Specifičan cilj korisnika]
                      </span>
                      . Njegove navike u ishrani su:
                      <span className="font-bold text-blue-500">
                        [Navike u ishrani]
                      </span>
                      . Njegove alergije su:
                      <span className="font-bold text-blue-500">
                        [Osip, svrab...]
                      </span>
                      . Ima intolerancije na:
                      <span className="font-bold text-blue-500">
                        [Gluten, laktoza]
                      </span> */}
                      :
                    </p>
                    {/* work here */}
                    <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Intolerancije:{" "}
                        <span className="font-semibold">[Gluten, laktoza]</span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                      <li>
                        Dijagnoza:{" "}
                        <span className="font-semibold">
                          [Zadravstvene dijagnoze]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                      <li>
                        Unos alkohola:{" "}
                        <span className="font-semibold">[Unos alkohola]</span>
                      </li>
                      <li>
                        Navika pušenja:{" "}
                        <span className="font-semibold">[Koliko cigareta]</span>
                      </li>
                    </ul>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definiši podatke za prompt:
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        type="button"
                        onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Sačuvaj
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="imun"
                    value={imunitetPrompt}
                    onChange={updateImunitetPrompt}
                    name="imun"
                    rows="20"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                  {/* Input za broj tokena */}
                  <div className="mt-4 mb-2">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                      Definiši broj karaktera za odgovor:
                    </h3>
                  </div>

                  <div className="flex justify-between w-full items-center">
                    <input
                      type="number"
                      name="imunBrKar"
                      value={imunBrKar}
                      onChange={handleEditImunBrKar}
                      className="block w-32 rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      placeholder="Imunitet"
                    />
                    <div className="text-lg text-gray-600">
                      {imunitetPrompt.length} karaktera
                    </div>
                  </div>
                </div>

                {/* end */}
              </div>
            )}

            {currentSubTabPrompt === "San" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Podaci sadržani u predpromptu:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  {/* <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i Prezime
                        Korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Težina:</strong> [Težina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Specifični Cilj:</strong> [Specifičan cilj
                        korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Nivo Fizičke Aktivnosti:</strong> [Nivo]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Navike u Ishrani:</strong> [Obroci u pravilnim
                        intervalima, uživanje u slatkišima, itd.]
                      </p>
                    </div>
                  </div> */}

                  <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti najbolje nudis preporuke za brigu o snu. Pružaj
                      detaljno objašnjenje o
                      {/* <span className="font-bold text-blue-500">
                        [Ime i Prezime Korisnika]
                      </span>{" "}
                      sa godinama:
                      <span className="font-bold text-blue-500">
                        [Godine korisnika]
                      </span>
                      , visina:
                      <span className="font-bold text-blue-500">
                        [Visina korisnika]
                      </span>
                      , sa težinom:
                      <span className="font-bold text-blue-500">
                        [Težina korisnika]
                      </span>
                      , pol:
                      <span className="font-bold text-blue-500">
                        [Pol korisnika]
                      </span>{" "}
                      može poboljšati svoj san, imajući u vidu da ima nivo
                      fizičke aktivnosti:
                      <span className="font-bold text-blue-500">[Nivo]</span>. A
                      ima specifične ciljeve:
                      <span className="font-bold text-blue-500">
                        [Specifičan cilj korisnika]
                      </span>{" "}
                      i navike u ishrani:
                      <span className="font-bold text-blue-500">
                        [Obroci u pravilnim intervalima, uživanje u slatkišima,
                        itd.]
                      </span> */}
                      :
                    </p>
                    <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Intolerancije:{" "}
                        <span className="font-semibold">[Gluten, laktoza]</span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                      <li>
                        Dijagnoza:{" "}
                        <span className="font-semibold">
                          [Zadravstvene dijagnoze]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                      <li>
                        Unos alkohola:{" "}
                        <span className="font-semibold">[Unos alkohola]</span>
                      </li>
                      <li>
                        Navika pušenja:{" "}
                        <span className="font-semibold">[Koliko cigareta]</span>
                      </li>
                    </ul>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definiši podatke za prompt:
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        type="button"
                        onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Sačuvaj
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="san"
                    value={sanPrompt}
                    onChange={updateSanPrompt}
                    name="san"
                    rows="20"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                  {/* Input za broj tokena */}
                  <div className="mt-4 mb-2">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                      Definiši broj karaktera za odgovor:
                    </h3>
                  </div>

                  <div className="flex justify-between w-full items-center">
                    <input
                      type="number"
                      name="sanBrKar"
                      value={sanBrKar}
                      onChange={handleEditSanBrKar}
                      className="block w-32 rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      placeholder="San"
                    />
                    <div className="text-lg text-gray-600">
                      {sanPrompt.length} karaktera
                    </div>
                  </div>
                </div>

                {/* end */}
              </div>
            )}

            {currentSubTabPrompt === "Unos vode" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Podaci sadržani u predpromptu:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  {/* <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i Prezime
                        Korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Trenutna težina:</strong> [Težina]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Nivo Fizičke Aktivnosti:</strong> [Nivo]
                      </p>
                    </div>
                  </div> */}

                  <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti najbolje nudis preporuke za brigu o unosu vode u
                      organizam. Pružaj detaljno objašnjenje o tome kako:
                      {/* <span className="font-bold text-blue-500">
                        [Ime i Prezime Korisnika]
                      </span>
                      <span className="font-bold text-blue-500">
                        [Pol korisnika]
                      </span>{" "}
                      sa
                      <span className="font-bold text-blue-500">
                        [Godine korisnika]
                      </span>{" "}
                      godina, sa težinom
                      <span className="font-bold text-blue-500">
                        [Težina]
                      </span>{" "}
                      i visinom
                      <span className="font-bold text-blue-500">
                        [Visina]
                      </span>{" "}
                      cm može poboljšati svoj unos vode, imajući u vidu da ima
                      nivo fizičke aktivnosti:
                      <span className="font-bold text-blue-500">[Nivo]</span>. */}
                    </p>
                    <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Intolerancije:{" "}
                        <span className="font-semibold">[Gluten, laktoza]</span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                      <li>
                        Dijagnoza:{" "}
                        <span className="font-semibold">
                          [Zadravstvene dijagnoze]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                      <li>
                        Unos alkohola:{" "}
                        <span className="font-semibold">[Unos alkohola]</span>
                      </li>
                      <li>
                        Navika pušenja:{" "}
                        <span className="font-semibold">[Koliko cigareta]</span>
                      </li>
                    </ul>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definiši podatke za prompt:
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        type="button"
                        onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Sačuvaj
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="voda"
                    value={vodaPrompt}
                    onChange={updateVodaPrompt}
                    name="voda"
                    rows="20"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                  {/* Input za broj tokena */}
                  <div className="mt-4 mb-2">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                      Definiši broj karaktera za odgovor:
                    </h3>
                  </div>

                  <div className="flex justify-between w-full items-center">
                    <input
                      type="number"
                      name="vodaBrKar"
                      value={vodaBrKar}
                      onChange={handleEditVodaBrKar}
                      className="block w-32 rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      placeholder="Voda"
                    />
                    <div className="text-lg text-gray-600">
                      {vodaPrompt.length} karaktera
                    </div>
                  </div>
                </div>

                {/* end */}
              </div>
            )}

            {currentSubTabPrompt === "Prethodna isk. dijeta" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Podaci sadržani u predpromptu:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  {/* <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i Prezime
                        Korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Težina:</strong> [Težina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Prethodna iskustva sa dijetama:</strong> [Neka
                        iskustva]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Motivacija:</strong> [Razlog zbog kojeg korisnik
                        želi promene]
                      </p>
                    </div>
                  </div> */}

                  <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti najbolje nudis preporuke o prethodnim iskustvima sa
                      dijetama. Pružaj detaljno objašnjenje o
                      {/* <span className="font-bold text-blue-500">
                        [Ime i Prezime Korisnika]
                      </span>
                      , sa godinama:
                      <span className="font-bold text-blue-500">
                        [Godine korisnika]
                      </span>
                      , visina:
                      <span className="font-bold text-blue-500">
                        [Visina korisnika]
                      </span>
                      , sa težinom:
                      <span className="font-bold text-blue-500">
                        [Težina korisnika]
                      </span>
                      , pol:
                      <span className="font-bold text-blue-500">
                        [Pol korisnika]
                      </span>
                      , sa ciljevima povećanje mišićne mase, i specifičnim
                      ciljem povećanje snage i motivacijom za:
                      <span className="font-bold text-blue-500">
                        [Razlog zbog kojeg korisnik želi promene]
                      </span>
                      . Sa prethodnim iskustvima:
                      <span className="font-bold text-blue-500">
                        [Neka iskustva]
                      </span> */}
                      :
                    </p>
                    <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Intolerancije:{" "}
                        <span className="font-semibold">[Gluten, laktoza]</span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                      <li>
                        Dijagnoza:{" "}
                        <span className="font-semibold">
                          [Zadravstvene dijagnoze]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                      <li>
                        Unos alkohola:{" "}
                        <span className="font-semibold">[Unos alkohola]</span>
                      </li>
                      <li>
                        Navika pušenja:{" "}
                        <span className="font-semibold">[Koliko cigareta]</span>
                      </li>
                    </ul>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definiši podatke za prompt:
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        type="button"
                        onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Sačuvaj
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="pret"
                    value={pretIskPrompt}
                    onChange={updatePretIskPrompt}
                    name="pret"
                    rows="20"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                  {/* Input za broj tokena */}
                  <div className="mt-4 mb-2">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                      Definiši broj karaktera za odgovor:
                    </h3>
                  </div>

                  <div className="flex justify-between w-full items-center">
                    <input
                      type="number"
                      name="pretIskBrKar"
                      value={pretIskBrKar}
                      onChange={handleEditPretIskBrKar}
                      className="block w-32 rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      placeholder="Prehrana"
                    />
                    <div className="text-lg text-gray-600">
                      {pretIskPrompt.length} karaktera
                    </div>
                  </div>
                </div>

                {/* end */}
              </div>
            )}

            {currentSubTabPrompt === "Alergije i intolerancije" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Podaci sadržani u predpromptu:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  {/* <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i Prezime
                        Korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Težina:</strong> [Težina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Alergije:</strong> [Osip, svrab...]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Intolerancije:</strong> [Gluten, laktoza]
                      </p>
                    </div>
                  </div> */}

                  <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti najbolje nudis preporuke za brigu o alergijama i
                      intolerancijama. Pružaj detaljno objašnjenje za
                      {/* <span className="font-bold text-blue-500">
                        [Ime i Prezime Korisnika]
                      </span>
                      , sa godinama:
                      <span className="font-bold text-blue-500">
                        [Godine korisnika]
                      </span>
                      , visina:
                      <span className="font-bold text-blue-500">
                        [Visina korisnika]
                      </span>
                      , sa težinom:
                      <span className="font-bold text-blue-500">
                        [Težina korisnika]
                      </span>
                      , pol:
                      <span className="font-bold text-blue-500">
                        [Pol korisnika]
                      </span>
                      , sa alergijama:
                      <span className="font-bold text-blue-500">
                        [Osip, svrab...]
                      </span>{" "}
                      i intolerancijama za:
                      <span className="font-bold text-blue-500">
                        [Gluten, laktoza]
                      </span> */}
                      :
                    </p>
                    <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Intolerancije:{" "}
                        <span className="font-semibold">[Gluten, laktoza]</span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                      <li>
                        Dijagnoza:{" "}
                        <span className="font-semibold">
                          [Zadravstvene dijagnoze]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                      <li>
                        Unos alkohola:{" "}
                        <span className="font-semibold">[Unos alkohola]</span>
                      </li>
                      <li>
                        Navika pušenja:{" "}
                        <span className="font-semibold">[Koliko cigareta]</span>
                      </li>
                    </ul>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definiši podatke za prompt:
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        type="button"
                        onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Sačuvaj
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="aleri"
                    value={alerginPrompt}
                    onChange={updateAlerginPrompt}
                    name="aleri"
                    rows="20"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                  {/* Input za broj tokena */}
                  <div className="mt-4 mb-2">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                      Definiši broj karaktera za odgovor:
                    </h3>
                  </div>

                  <div className="flex justify-between w-full items-center">
                    <input
                      type="number"
                      name="alerIshBrKar"
                      value={alerIshBrKar}
                      onChange={handleEditAlerIshBrKar}
                      className="block w-32 rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      placeholder="Alergeni"
                    />
                    <div className="text-lg text-gray-600">
                      {alerginPrompt.length} karaktera
                    </div>
                  </div>
                </div>

                {/* end */}
              </div>
            )}
            {currentSubTabPrompt === "Alkohol" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Podaci sadržani u predpromptu:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  {/* <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i Prezime
                        Korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Težina:</strong> [Težina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Primaran cilj:</strong> [Primarni cilj
                        korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Unos alkohola:</strong> [Unos alkohola]
                      </p>
                    </div>
                  </div> */}

                  <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti najbolje nudis preporuke za brigu o unosu alkohola u
                      organizam. Pružaj detaljno objašnjenje o
                      {/* <span className="font-bold text-blue-500">
                        [Ime i Prezime Korisnika]
                      </span>
                      , sa godinama:
                      <span className="font-bold text-blue-500">
                        [Godine korisnika]
                      </span>
                      , visina:
                      <span className="font-bold text-blue-500">
                        [Visina korisnika]
                      </span>
                      , sa težinom:
                      <span className="font-bold text-blue-500">
                        [Težina korisnika]
                      </span>
                      , pol:
                      <span className="font-bold text-blue-500">
                        [Pol korisnika]
                      </span>
                      , koji želi da postigne:
                      <span className="font-bold text-blue-500">
                        [Primarni cilj korisnika]
                      </span>{" "}
                      i
                      <span className="font-bold text-blue-500">
                        [Specifičan cilj korisnika]
                      </span>{" "}
                      a konzumira:
                      <span className="font-bold text-blue-500">
                        [Unos alkohola]
                      </span> */}
                      :
                    </p>
                    <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Intolerancije:{" "}
                        <span className="font-semibold">[Gluten, laktoza]</span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                      <li>
                        Dijagnoza:{" "}
                        <span className="font-semibold">
                          [Zadravstvene dijagnoze]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                      <li>
                        Unos alkohola:{" "}
                        <span className="font-semibold">[Unos alkohola]</span>
                      </li>
                      <li>
                        Navika pušenja:{" "}
                        <span className="font-semibold">[Koliko cigareta]</span>
                      </li>
                    </ul>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definiši podatke za prompt:
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        type="button"
                        onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Sačuvaj
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="alkohol"
                    value={alkoholPrompt}
                    onChange={updateAlkoholPrompt}
                    name="alkohol"
                    rows="20"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                  {/* Input za broj tokena */}
                  <div className="mt-4 mb-2">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                      Definiši broj karaktera za odgovor:
                    </h3>
                  </div>

                  <div className="flex justify-between w-full items-center">
                    <input
                      type="number"
                      name="alkoholBrKar"
                      value={alkoholBrKar}
                      onChange={handleEditAlkoholBrKar}
                      className="block w-32 rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      placeholder="Alkohol"
                    />
                    <div className="text-lg text-gray-600">
                      {alkoholPrompt.length} karaktera
                    </div>
                  </div>
                </div>

                {/* end */}
              </div>
            )}
            {currentSubTabPrompt === "Pušenje" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Podaci sadržani u predpromptu:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  {/* <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i Prezime
                        Korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Težina:</strong> [Težina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Primaran cilj:</strong> [Primarni cilj
                        korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Navika pušenja:</strong> [Koliko cigareta]
                      </p>
                    </div>
                  </div> */}

                  <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti najbolje nudis preporuke za brigu o pušenju cigareta.
                      Pružaj detaljno objašnjenje o
                      {/* <span className="font-bold text-blue-500">
                        [Ime i Prezime Korisnika]
                      </span>
                      , sa godinama:
                      <span className="font-bold text-blue-500">
                        [Godine korisnika]
                      </span>
                      , visina:
                      <span className="font-bold text-blue-500">
                        [Visina korisnika]
                      </span>
                      , sa težinom:
                      <span className="font-bold text-blue-500">
                        [Težina korisnika]
                      </span>
                      , pol:
                      <span className="font-bold text-blue-500">
                        [Pol korisnika]
                      </span>
                      , koji želi da postigne:
                      <span className="font-bold text-blue-500">
                        [Primarni cilj korisnika]
                      </span>{" "}
                      i
                      <span className="font-bold text-blue-500">
                        [Sekundarni cilj korisnika]
                      </span>{" "}
                      a konzumira:
                      <span className="font-bold text-blue-500">
                        [Koliko cigareta]
                      </span> */}
                      :
                    </p>
                    <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Intolerancije:{" "}
                        <span className="font-semibold">[Gluten, laktoza]</span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                      <li>
                        Dijagnoza:{" "}
                        <span className="font-semibold">
                          [Zadravstvene dijagnoze]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                      <li>
                        Unos alkohola:{" "}
                        <span className="font-semibold">[Unos alkohola]</span>
                      </li>
                      <li>
                        Navika pušenja:{" "}
                        <span className="font-semibold">[Koliko cigareta]</span>
                      </li>
                    </ul>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definiši podatke za prompt:
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        type="button"
                        onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Sačuvaj
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="pusenje"
                    value={pusenjePrompt}
                    onChange={updatePusenjePrompt}
                    name="pusenje"
                    rows="20"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                  {/* Input za broj tokena */}
                  <div className="mt-4 mb-2">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                      Definiši broj karaktera za odgovor:
                    </h3>
                  </div>

                  <div className="flex justify-between w-full items-center">
                    <input
                      type="number"
                      name="pusenjeBrKar"
                      value={pusenjeBrKar}
                      onChange={handleEditPusenjeBrKar}
                      className="block w-32 rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      placeholder="Pusenje"
                    />
                    <div className="text-lg text-gray-600">
                      {pusenjePrompt.length} karaktera
                    </div>
                  </div>
                </div>

                {/* end */}
              </div>
            )}

            {currentSubTabPrompt === "Zakljucak" && (
              <div className="block w-full h-100">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Podaci sadržani u predpromptu:
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* Preview podataka za predprompt - oni koje se salju u chat */}
                  {/* <div className="bg-white p-2 rounded-lg shadow-md my-1 border border-red-500 inline-block">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Ime i Prezime:</strong> [Ime i prezime
                        korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Godine:</strong> [Godine korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Visina:</strong> [Visina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Težina:</strong> [Težina korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Pol:</strong> [Pol korisnika]
                      </p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        <strong>Primaran cilj:</strong> [Primarni cilj
                        korisnika]
                      </p>
                    </div>
                  </div> */}

                  <div className="p-4 mt-2 bg-gray-100 rounded-lg shadow-lg max-w-full mx-auto">
                    <p className="text-lg text-gray-800">
                      Ti najbolje nudis zaključke o planu ishrane. Pružaj
                      detaljna objašnjenja za
                      {/* <span className="font-bold text-blue-500">
                        [Ime i prezime korisnika]
                      </span>
                      , sa godinama:
                      <span className="font-bold text-blue-500">
                        [Godine korisnika]
                      </span>
                      , visina:
                      <span className="font-bold text-blue-500">
                        [Visina korisnika]
                      </span>
                      , sa težinom:
                      <span className="font-bold text-blue-500">
                        [Težina korisnika]
                      </span>
                      , pol:
                      <span className="font-bold text-blue-500">
                        [Pol korisnika]
                      </span>
                      . Njegov/a primarni cilj ishrane je
                      <span className="font-bold text-blue-500">
                        [Primarni cilj korisnika]
                      </span> */}
                      :
                    </p>
                    <ul className="list-disc list-inside text-gray-600 mb-4">
                      <li>
                        Ime i prezime:{" "}
                        <span className="font-semibold">
                          [Ime i prezime korisnika]
                        </span>
                      </li>
                      <li>
                        Godine:{" "}
                        <span className="font-semibold">
                          [Godine korisnika]
                        </span>
                      </li>
                      <li>
                        Visina:{" "}
                        <span className="font-semibold">
                          [Visina korisnika] cm
                        </span>
                      </li>
                      <li>
                        Težina:{" "}
                        <span className="font-semibold">
                          [Težina korisnika] kg
                        </span>
                      </li>
                      <li>
                        Pol:{" "}
                        <span className="font-semibold">[Pol korisnika]</span>
                      </li>
                      <li>
                        Primarni cilj:{" "}
                        <span className="font-semibold">
                          [Primarni cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Specifičan cilj:{" "}
                        <span className="font-semibold">
                          [Specifičan cilj korisnika]
                        </span>
                      </li>
                      <li>
                        Motivacija za promenu:{" "}
                        <span className="font-semibold">
                          [Motivacija za promenu korisnika]
                        </span>
                      </li>
                      <li>
                        Trenutne navike u ishrani:{" "}
                        <span className="font-semibold">
                          [Navike u ishrani korisnika]
                        </span>
                      </li>
                      <li>
                        Stil ishrane:{" "}
                        <span className="font-semibold">
                          [Vegetarijanska, keto, veganska, itd.]
                        </span>
                      </li>
                      <li>
                        Učestalost obroka:{" "}
                        <span className="font-semibold">
                          [Učestalost obroka korisnika]
                        </span>
                      </li>
                      <li>
                        Nivo aktivnosti:{" "}
                        <span className="font-semibold">
                          [Nivo aktivnosti korisnika]
                        </span>
                      </li>
                      <li>
                        Vrsta fizičke aktivnosti:{" "}
                        <span className="font-semibold">
                          [Trčanje, biciklizam, vežbanje u teretani, itd.]
                        </span>
                      </li>
                      <li>
                        Prethodna iskustva sa dijetama:{" "}
                        <span className="font-semibold">
                          [Prethodna iskustva korisnika sa dijetama]
                        </span>
                      </li>
                      <li>
                        Alergije:{" "}
                        <span className="font-semibold">
                          [Alergije korisnika]
                        </span>
                      </li>
                      <li>
                        Intolerancije:{" "}
                        <span className="font-semibold">[Gluten, laktoza]</span>
                      </li>
                      <li>
                        Namirnice koje voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik voli]
                        </span>
                      </li>
                      <li>
                        Namirnice koje ne voli:{" "}
                        <span className="font-semibold">
                          [Namirnice koje korisnik ne voli]
                        </span>
                      </li>
                      <li>
                        Zdravstveni problemi:{" "}
                        <span className="font-semibold">
                          [Zdravstveni problemi korisnika]
                        </span>
                      </li>
                      <li>
                        Dijagnoza:{" "}
                        <span className="font-semibold">
                          [Zadravstvene dijagnoze]
                        </span>
                      </li>
                      <li>
                        Stanje imuniteta:{" "}
                        <span className="font-semibold">[Slab/Jak]</span>
                      </li>
                      <li>
                        Unos alkohola:{" "}
                        <span className="font-semibold">[Unos alkohola]</span>
                      </li>
                      <li>
                        Navika pušenja:{" "}
                        <span className="font-semibold">[Koliko cigareta]</span>
                      </li>
                    </ul>
                  </div>

                  <div className="-ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4">
                      <div className="space-y-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Definiši podatke za prompt:
                        </h3>
                      </div>
                    </div>
                    <div className="ml-4 my-3 flex-shrink-0">
                      <button
                        type="button"
                        onClick={updatePrompts}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Sačuvaj
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="zakljucak"
                    value={zakljucakPrompt}
                    onChange={updateZakljucakPrompt}
                    name="zakljucak"
                    rows="20"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                  {/* Input za broj tokena */}
                  <div className="mt-4 mb-2">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                      Definiši broj karaktera za odgovor:
                    </h3>
                  </div>

                  <div className="flex justify-between w-full items-center">
                    <input
                      type="number"
                      name="zakljucak"
                      value={zakljucakBrKar}
                      onChange={handleEditZakljucakBrKar}
                      className="block w-32 rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      placeholder="Zakljucak"
                    />
                    <div className="text-lg text-gray-600">
                      {zakljucakPrompt.length} karaktera
                    </div>
                  </div>
                </div>

                {/* end */}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Chet komunikacija */}
      {currentTab === "Čet konverzcija" && (
        <div className="block w-full h-max rounded bg-white p-2 border-gray-300">
          {/* Dropdown za mobilne uređaje */}
          <div className="sm:hidden">
            <label htmlFor="sub-tabs-chat" className="sr-only">
              Select a sub-tab
            </label>
            <select
              id="sub-tabs-chat"
              name="sub-tabs-chat"
              className="block w-full rounded border-gray-300 focus:border-blue-500 focus:ring-blue-500"
              value={currentSubTabChetConv}
              onChange={handleSubTabSelectChangeChatConv}
            >
              {subTabsChat.map((subTab) => (
                <option key={subTab.name} value={subTab.name}>
                  {subTab.name}
                </option>
              ))}
            </select>
          </div>

          {/* Navigacija za desktop */}
          <div className="hidden sm:block">
            <nav
              className="isolate flex divide-x divide-gray-200 rounded shadow"
              aria-label="Sub-tabs"
            >
              {subTabsChat.map((subTab, subTabIdx) => (
                <a
                  key={subTab.name}
                  href={subTab.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubTabSelectChangeChatConv(subTab.name);
                  }}
                  className={classNames(
                    subTab.name === currentSubTabChetConv
                      ? "text-gray-900"
                      : "text-gray-500 hover:text-gray-700",
                    subTabIdx === 0 ? "rounded-tl rounded-bl" : "",
                    subTabIdx === subTabsChat.length - 1
                      ? "rounded-tr rounded-br"
                      : "",
                    "group relative w-1/2 overflow-hidden bg-white px-4 py-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
                  )}
                  aria-current={
                    subTab.name === currentSubTabChetConv ? "page" : undefined
                  }
                >
                  <span>{subTab.name}</span>
                  <span
                    aria-hidden="true"
                    className={classNames(
                      subTab.name === currentSubTabChetConv
                        ? "bg-blue-500"
                        : "bg-transparent",
                      "absolute inset-x-0 bottom-0 h-0.5"
                    )}
                  />
                </a>
              ))}
            </nav>
          </div>

          {/* Sadržaj za podtabove */}
          <div className="color">
            {/* Lista četa */}
            <div className="block w-full h-100 bg-gray-100 p-2">
              <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                  <div className="ml-4 mt-2">
                    <div className="flex items-center space-x-2">
                      <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                        Svi chetovi
                      </h3>
                    </div>
                  </div>
                </div>

                <ul className="mt-4">
                  {sviChetovi && sviChetovi.length > 0 ? (
                    sviChetovi
                      .slice()
                      .reverse()
                      .map((chet) => (
                        <li
                          key={chet._id}
                          className="flex justify-between items-center border-b border-gray-200 py-3"
                        >
                          {/* Datum i primCilj */}
                          <span className="text-md font-semibold text-gray-900">
                            {chet.datum || "Nepoznati datum"} - {chet?.vreme} -{" "}
                            {chet.primCilj || "Nepoznati cilj"} -{" "}
                            {chet.name || "Nepostojeće ime"}{" "}
                            {chet.lastname || "Neostojeće prezime"}
                          </span>

                          {/* Dugme Pogledaj */}
                          <div className="flex items-center">
                            <button
                              onClick={() => handleDelChat(chet._id)}
                              className="ml-4 text-red-600 hover:text-red-500"
                            >
                              Izbriši
                            </button>
                            <button
                              onClick={() => openModalChat(chet)}
                              className="ml-4 text-blue-600 hover:text-blue-500"
                            >
                              Pogledaj
                            </button>
                          </div>
                        </li>
                      ))
                  ) : (
                    <p className="text-gray-500 mt-2">Nema dostupnih četova.</p>
                  )}
                </ul>
              </div>
            </div>

            {/* PRIKAZ POPUP-A */}
            {isModalOpenChat && selectedChat && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white rounded-lg shadow-lg p-8 max-w-5xl w-full max-h-[95vh] overflow-auto">
                  {/* Header */}
                  <div className="flex justify-between items-center border-b pb-4">
                    <h2 className="text-2xl font-semibold text-gray-800">
                      Detalji četa
                    </h2>
                    <button
                      onClick={closeModalChat}
                      className="text-gray-500 hover:text-gray-800 text-xl"
                    >
                      ✖
                    </button>
                  </div>

                  {/* Sadržaj */}
                  <div className="mt-6 space-y-6">
                    {/* Sekcije */}
                    {[
                      { name: "Uvod", key: "uvod" },
                      { name: "Holistički Pristup", key: "holistickiPristup" },
                      { name: "Plan Ishrane", key: "planIshrane" },
                      { name: "Smernice", key: "smernice" },
                      {
                        name: "Plan Fizičke Aktivnosti",
                        key: "planFizickeAktivnosti",
                      },
                      { name: "Podrška za Imunitet", key: "podrskaZaImunitet" },
                      { name: "Saveti za Spavanje", key: "spavanjeSavet" },
                      { name: "Unos Vode", key: "unosVode" },
                      { name: "Pušenje", key: "pusenje" },
                      { name: "Alkohol", key: "alkohol" },
                      { name: "Zaključak", key: "zakljucak" },
                      // { name: "Dani", key: "dani" },
                    ].map((section) => (
                      <div key={section.key}>
                        <h3 className="text-lg font-medium text-gray-900 mb-2">
                          {section.name}
                        </h3>
                        <p className="text-sm text-gray-700">
                          <strong>Pred {section.name}:</strong>{" "}
                          {selectedChat.poslatiPrompt?.[
                            `pred${capitalizeFirstLetter(section.key)}`
                          ] || "N/A"}
                        </p>
                        <p className="text-sm text-gray-700">
                          <strong>{section.name} (Poslati Prompt):</strong>{" "}
                          {selectedChat.poslatiPrompt?.[section.key] || "N/A"}
                        </p>
                        <p className="text-sm text-gray-700">
                          <strong>{section.name} (Odgovor):</strong>{" "}
                          {selectedChat.odgovor?.[section.key] || "N/A"}
                        </p>
                      </div>
                    ))}

                    {/* Sekcija: Dani*/}
                    <h3 className="text-lg font-medium text-gray-900">Dani</h3>
                    <p className="text-sm text-gray-700">
                      <strong>Poslati predprompt:</strong>{" "}
                      {selectedChat.poslatiPrompt?.predDani || "Nema"}
                    </p>
                    <p className="text-sm text-gray-700">
                      <strong>Poslati prompt:</strong>{" "}
                      {selectedChat.poslatiPrompt?.dani || "Nema"}
                    </p>

                    {selectedChat.odgovor?.dani && (
                      <div>
                        <h3 className="text-lg font-medium text-gray-900 mb-2">
                          Odgovor Dani:
                        </h3>
                        <div className="space-y-4">
                          {(typeof selectedChat.odgovor.dani === "string"
                            ? JSON.parse(selectedChat.odgovor.dani)
                            : selectedChat.odgovor.dani
                          ).map((day, index) => (
                            <div
                              key={index}
                              className="border border-gray-300 rounded-lg p-4 bg-gray-50"
                            >
                              <h4 className="text-lg font-medium text-gray-800 mb-2">
                                {day.dan || `Dan ${index + 1}`}
                              </h4>
                              {Object.entries(day).map(
                                ([mealKey, mealValue]) => {
                                  if (
                                    mealKey !== "dan" &&
                                    typeof mealValue === "object" &&
                                    mealValue !== null
                                  ) {
                                    return (
                                      <div key={mealKey} className="mb-4">
                                        <h5 className="font-semibold text-gray-800 capitalize mb-1">
                                          {mealKey.charAt(0).toUpperCase() +
                                            mealKey.slice(1)}
                                        </h5>
                                        <div className="ml-4 space-y-1">
                                          <p className="text-sm text-gray-700">
                                            <strong>Opis:</strong>{" "}
                                            {mealValue.opis || "N/A"}
                                          </p>
                                          <p className="text-sm text-gray-700">
                                            <strong>Sastojci:</strong>{" "}
                                            {mealValue.sastojci || "N/A"}
                                          </p>
                                          <p className="text-sm text-gray-700">
                                            <strong>Instrukcije:</strong>{" "}
                                            {mealValue.instrukcije || "N/A"}
                                          </p>
                                          <p className="text-sm text-gray-700">
                                            <strong>Kalorije:</strong>{" "}
                                            {mealValue.kalorije || "N/A"}
                                          </p>
                                          <p className="text-sm text-gray-700">
                                            <strong>
                                              Nutritivna vrednost:
                                            </strong>{" "}
                                            {mealValue.nutritivna_vrednost ||
                                              "N/A"}
                                          </p>
                                          {mealValue.Makronutrijenti && (
                                            <div>
                                              <h6 className="font-semibold text-gray-800">
                                                Makronutrijenti:
                                              </h6>
                                              <ul className="list-disc list-inside">
                                                {Object.entries(
                                                  mealValue.Makronutrijenti
                                                ).map(([nutrient, value]) => (
                                                  <li
                                                    key={nutrient}
                                                    className="text-sm text-gray-700"
                                                  >
                                                    <strong>{nutrient}:</strong>{" "}
                                                    {value}
                                                  </li>
                                                ))}
                                              </ul>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  }
                                  return null;
                                }
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    {/* {selectedChat.odgovor?.dani && (
                      <div>
                        <h3 className="text-lg font-medium text-gray-900 mb-2">
                          Odgovor Dani:
                        </h3>
                        <div className="space-y-4">
                          {(typeof selectedChat.odgovor.dani === "string"
                            ? JSON.parse(selectedChat.odgovor.dani)
                            : selectedChat.odgovor.dani
                          ).map((day, index) => (
                            <div
                              key={index}
                              className="border border-gray-300 rounded-lg p-4 bg-gray-50"
                            >
                              <h4 className="text-lg font-medium text-gray-800 mb-2">
                                {day.dan || `Dan ${index + 1}`}
                              </h4>
                              {Object.entries(day).map(
                                ([mealKey, mealValue]) => {
                                  if (
                                    mealKey !== "dan" &&
                                    typeof mealValue === "object"
                                  ) {
                                    return (
                                      <div key={mealKey} className="mb-4">
                                        <h5 className="font-semibold text-gray-800 capitalize mb-1">
                                          {mealKey.replace(/([A-Z])/g, " $1")}
                                        </h5>
                                        <div className="ml-4 space-y-1">
                                          {Object.entries(mealValue).map(
                                            ([subKey, subValue]) => (
                                              <p
                                                key={subKey}
                                                className="text-sm text-gray-700"
                                              >
                                                <strong>
                                                  {subKey.replace(
                                                    /([A-Z])/g,
                                                    " $1"
                                                  )}
                                                  :{" "}
                                                </strong>
                                                {subValue || "N/A"}
                                              </p>
                                            )
                                          )}
                                        </div>
                                      </div>
                                    );
                                  }
                                  return null;
                                }
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )} */}
                  </div>

                  {/* Footer */}
                  <div className="mt-6 text-right">
                    <button
                      onClick={closeModalChat}
                      className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                      Zatvori
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {currentTab === "Kodovi" && (
        <div className="block w-full h-100 rounded bg-white p-2 border-gray-300">
          {/* Sub-tabs for "Kodovi" */}
          <div className="sm:hidden">
            <label htmlFor="sub-tabs" className="sr-only">
              Select a sub-tab
            </label>
            <select
              id="sub-tabs"
              name="sub-tabs"
              className="block w-full rounded border-gray-300 focus:border-blue-500 focus:ring-blue-500"
              value={currentSubTab}
              onChange={handleSubTabSelectChange}
            >
              {subTabsKodovi.map((subTab) => (
                <option key={subTab.name} value={subTab.name}>
                  {subTab.name}
                </option>
              ))}
            </select>
          </div>
          <div className="hidden sm:block">
            <nav
              className="isolate flex divide-x divide-gray-200 rounded shadow"
              aria-label="Sub-tabs"
            >
              {subTabsKodovi.map((subTab, subTabIdx) => (
                <a
                  key={subTab.name}
                  href={subTab.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubTabClick(subTab.name);
                  }}
                  className={classNames(
                    subTab.name === currentSubTab
                      ? "text-gray-900"
                      : "text-gray-500 hover:text-gray-700",
                    subTabIdx === 0 ? "rounded-tl rounded-bl" : "",
                    subTabIdx === subTabsKodovi.length - 1
                      ? "rounded-tr rounded-br"
                      : "",
                    "group relative w-1/2 overflow-hidden bg-white px-4 py-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
                  )}
                  aria-current={
                    subTab.name === currentSubTab ? "page" : undefined
                  }
                >
                  <span>{subTab.name}</span>
                  <span
                    aria-hidden="true"
                    className={classNames(
                      subTab.name === currentSubTab
                        ? "bg-blue-500"
                        : "bg-transparent",
                      "absolute inset-x-0 bottom-0 h-0.5"
                    )}
                  />
                </a>
              ))}
            </nav>
          </div>

          {/* Sub-tab Kodovi */}
          <div className="color">
            {currentSubTab === "Svi kodovi" && (
              <div className="block w-full h-100 bg-gray-100 p-2">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="flex items-center space-x-2">
                        <form>
                          <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                            Unesi ime novog koda:
                          </h3>
                          <input
                            id="primcilj-naziv"
                            value={kodNaziv}
                            onChange={onNazivKodnaPromenjen}
                            name="primciljNaziv"
                            type="text"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                          />

                          <br />

                          <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                            Unesi opis koda:
                          </h3>
                          <textarea
                            id="primcilj-opis"
                            value={opisKod}
                            onChange={onopiskodaPromenjen}
                            name="primciljOpis"
                            type="text"
                            className="block w-96 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                          />
                        </form>
                      </div>
                    </div>
                    <div className="ml-4 mt-2 flex-shrink-0">
                      <button
                        type="button"
                        onClick={handleAddKod}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Dodaj
                      </button>
                    </div>
                  </div>

                  <ul className="mt-4">
                    {sviKodovi
                      .slice()
                      .reverse()
                      .map((job) => (
                        <li
                          key={job._id}
                          className="flex justify-between items-center border-b border-gray-200 py-3"
                        >
                          <div>
                            <span className="text-md font-semibold text-gray-900 underline">
                              {job.naziv}
                            </span>
                            <p className="text-sm text-gray-900 mt-2">
                              {job.opis}
                            </p>
                          </div>
                          <div className="flex items-center">
                            {/* <button
                              onClick={() => openEditModalPrimCilj(job)}
                              className="ml-4 text-blue-600 hover:text-blue-500"
                            >
                              Izmeni
                            </button> */}
                            <button
                              onClick={() => handleDelKod(job._id)}
                              className="ml-4 text-red-600 hover:text-red-500"
                            >
                              Ukloni
                            </button>
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>

                {isEditModalOpenPrimCilj && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto">
                    <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-md mx-4">
                      <button
                        onClick={closeEditModalPrimCilj}
                        className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 focus:outline-none text-2xl"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        &times;
                      </button>
                      <h2 className="text-lg font-semibold mb-4 text-center">
                        Unesite nov naziv cilja
                      </h2>
                      <div className="flex items-center mb-4">
                        <input
                          id="inputField"
                          type="text"
                          value={inputValuePrimCilj}
                          onChange={handleInputChange}
                          className="border rounded px-2 py-1 w-full"
                          placeholder={`Trenutno: ${
                            selectedJobPrimCilj?.naziv || ""
                          }`}
                        />
                      </div>
                      <div className="flex justify-end">
                        <button
                          onClick={closeEditModalPrimCilj}
                          className="px-4 py-2 mr-1 bg-blue-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                        >
                          Ugasi
                        </button>
                        <button
                          onClick={handleConfirmEditPrimCilj}
                          className="px-4 py-2 ml-1 bg-red-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                        >
                          Izmeni
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* {isEditModalOpenSpecCilj && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto">
                <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-md mx-4">
                  <button
                    onClick={closeEditModalSpecCilj}
                    className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 focus:outline-none text-2xl"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    &times;
                  </button>
                  <h2 className="text-lg font-semibold mb-4 text-center">
                    Unesite izmenu cilja
                  </h2>
                  <div className="flex items-center mb-4">
                    <input
                      id="inputField"
                      type="text"
                      value={inputValueSpecCilj}
                      onChange={handleInputChangeSpecCilj}
                      className="border rounded px-2 py-1 w-full"
                      placeholder={`Trenutno: ${
                        selectedJobSpecCilj?.naziv || ""
                      }`}
                    />
                  </div>
                  <div className="flex justify-end">
                    <button
                      onClick={closeEditModalSpecCilj}
                      className="px-4 py-2 mr-1 bg-blue-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                    >
                      Ugasi
                    </button>
                    <button
                      onClick={handleConfirmEditSpecCilj}
                      className="px-4 py-2 ml-1 bg-red-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                    >
                      Izmeni
                    </button>
                  </div>
                </div>
              </div>
            )} */}

            {/* {currentSubTab === "Motivacija za promenu" && (
              <div className="block w-full h-100 bg-gray-100 p-2 border-black">
                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
                  <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                      <div className="flex items-center space-x-2">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                          Unesi motivaciju:
                        </h3>
                        <input
                          id="motiv"
                          value={motivNaziv}
                          onChange={onMotivChanged}
                          name="motiv"
                          type="text"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>
                    <div className="ml-4 mt-2 flex-shrink-0">
                      <button
                        type="button"
                        onClick={handleAddMotiv}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                      >
                        Dodaj
                      </button>
                    </div>
                  </div>

                  <ul className="mt-4">
                    {motivi
                      .slice()
                      .reverse()
                      .map((job) => (
                        <li
                          key={job._id}
                          className="flex justify-between items-center border-b border-gray-200 py-3"
                        >
                          <span className="text-md font-semibold text-gray-900">
                            {job.naziv}
                          </span>
                          <div className="flex items-center">
                            <button
                              onClick={() => openEditModalMotiv(job)}
                              className="ml-4 text-blue-600 hover:text-blue-500"
                            >
                              Izmeni
                            </button>
                            <button
                              onClick={() => handleDelMotiv(job._id)}
                              className="ml-4 text-red-600 hover:text-red-500"
                            >
                              Ukloni
                            </button>
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            )} */}
          </div>
        </div>
      )}

      {isEditModalOpenMotiv && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto">
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-md mx-4">
            <button
              onClick={closeEditModalMotiv}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 focus:outline-none text-2xl"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              &times;
            </button>
            <h2 className="text-lg font-semibold mb-4 text-center">
              Unesite izmenu cilja
            </h2>
            <div className="flex items-center mb-4">
              <input
                id="inputField"
                type="text"
                value={inputValueMotiv}
                onChange={handleInputChangeMotiv}
                className="border rounded px-2 py-1 w-full"
                placeholder={`Trenutno: ${selectedJobMotiv?.naziv || ""}`}
              />
            </div>
            <div className="flex justify-end">
              <button
                onClick={closeEditModalMotiv}
                className="px-4 py-2 mr-1 bg-blue-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
              >
                Ugasi
              </button>
              <button
                onClick={handleConfirmEditMotiv}
                className="px-4 py-2 ml-1 bg-red-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
              >
                Izmeni
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <>
      {tabovi}
      <br />
    </>
  );
};

export default Podesavanja;

// {isModalOpenChat && selectedChat && (
//   <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//     <div className="bg-white rounded-lg shadow-lg p-6 max-w-3xl w-full max-h-[90vh] overflow-auto">
//       {/* Header */}
//       <div className="flex justify-between items-center border-b pb-4">
//         <h2 className="text-xl font-semibold text-gray-800">Detalji četa</h2>
//         <button
//           onClick={closeModalChat}
//           className="text-gray-500 hover:text-gray-800"
//         >
//           ✖
//         </button>
//       </div>

//       {/* Sadržaj */}
//       <div className="mt-4 space-y-6">
//         {Object.entries(selectedChat).map(([key, value]) => {
//           if (key === "odgovor" && value.dani) {
//             // Proverite da li je "dani" string ili objekat
//             let parsedDani = [];
//             if (typeof value.dani === "string") {
//               try {
//                 parsedDani = JSON.parse(value.dani);
//               } catch (error) {
//                 console.error("Error parsing dani:", error);
//               }
//             } else if (Array.isArray(value.dani)) {
//               parsedDani = value.dani;
//             }

//             return (
//               <div key={key} className="border-b pb-4">
//                 <h3 className="font-semibold text-gray-900 capitalize mb-2">Dani</h3>
//                 <div className="space-y-4">
//                   {parsedDani.map((day, index) => (
//                     <div
//                       key={index}
//                       className="border border-gray-300 rounded-lg p-4 bg-gray-50"
//                     >
//                       <h4 className="text-lg font-medium text-gray-800 mb-2">
//                         {day.dan || `Dan ${index + 1}`}
//                       </h4>
//                       {Object.entries(day).map(([mealKey, mealValue]) => {
//                         if (mealKey !== "dan" && typeof mealValue === "object") {
//                           return (
//                             <div key={mealKey} className="mb-4">
//                               <h5 className="font-semibold text-gray-800 capitalize mb-1">
//                                 {mealKey.replace(/([A-Z])/g, " $1")}
//                               </h5>
//                               <div className="ml-4 space-y-1">
//                                 {Object.entries(mealValue).map(
//                                   ([subKey, subValue]) => (
//                                     <p
//                                       key={subKey}
//                                       className="text-sm text-gray-700"
//                                     >
//                                       <strong>
//                                         {subKey.replace(/([A-Z])/g, " $1")}:{" "}
//                                       </strong>
//                                       {subValue || "N/A"}
//                                     </p>
//                                   )
//                                 )}
//                               </div>
//                             </div>
//                           );
//                         }
//                         return null;
//                       })}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             );
//           }

//           if (key === "poslatiPrompt" && value.dani) {
//             return (
//               <div key={key} className="border-b pb-4">
//                 <h3 className="font-semibold text-gray-900 capitalize mb-2">
//                   Dani iz Poslati Prompt
//                 </h3>
//                 <p className="text-sm text-gray-700">{value.dani}</p>
//               </div>
//             );
//           }

//           return (
//             <div key={key} className="border-b pb-4">
//               <h3 className="font-semibold text-gray-900 capitalize mb-2">
//                 {key.replace(/([A-Z])/g, " $1")}
//               </h3>
//               {typeof value === "object" && value !== null ? (
//                 <div className="ml-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
//                   {Object.entries(value).map(([subKey, subValue]) => (
//                     <div key={subKey} className="text-sm text-gray-700">
//                       <strong className="text-gray-800">
//                         {subKey.replace(/([A-Z])/g, " $1")}:{" "}
//                       </strong>
//                       {subValue || "N/A"}
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <p className="text-sm text-gray-700">{value || "N/A"}</p>
//               )}
//             </div>
//           );
//         })}
//       </div>

//       {/* Footer */}
//       <div className="mt-6 text-right">
//         <button
//           onClick={closeModalChat}
//           className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
//         >
//           Zatvori
//         </button>
//       </div>
//     </div>
//   </div>
// )}

// {/* Modal za prikaz detalja */}
// {isModalOpenChat && selectedChat && (
//   <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//     <div className="bg-white rounded-lg shadow-lg p-6 max-w-3xl w-full max-h-[90vh] overflow-auto">
//       {/* Header */}
//       <div className="flex justify-between items-center border-b pb-4">
//         <h2 className="text-xl font-semibold text-gray-800">Detalji četa</h2>
//         <button
//           onClick={closeModalChat}
//           className="text-gray-500 hover:text-gray-800"
//         >
//           ✖
//         </button>
//       </div>

//       {/* Sadržaj */}
//       <div className="mt-4 space-y-6">
//         {/* Osnovni podaci */}
//         <div>
//           <h3 className="text-lg font-medium text-gray-900 mb-2">Osnovni podaci</h3>
//           <p className="text-sm text-gray-700">
//             <strong>Datum:</strong> {selectedChat.datum || "N/A"}
//           </p>
//           <p className="text-sm text-gray-700">
//             <strong>Vreme:</strong> {selectedChat.vreme || "N/A"}
//           </p>
//           <p className="text-sm text-gray-700">
//             <strong>Primarni cilj:</strong> {selectedChat.primCilj || "N/A"}
//           </p>
//         </div>

//         {/* Poslati Prompt */}
//         {selectedChat.poslatiPrompt && (
//           <div>
//             <h3 className="text-lg font-medium text-gray-900 mb-2">Poslati Prompt</h3>
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               {Object.entries(selectedChat.poslatiPrompt).map(([key, value]) => (
//                 <p key={key} className="text-sm text-gray-700">
//                   <strong>{key.replace(/([A-Z])/g, " $1")}: </strong>
//                   {value || "N/A"}
//                 </p>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Dani iz odgovora */}
//         {selectedChat.odgovor?.dani && (
//           <div>
//             <h3 className="text-lg font-medium text-gray-900 mb-2">Dani</h3>
//             {/* Parsiraj JSON string ako je potrebno */}
//             <div className="space-y-4">
//               {(typeof selectedChat.odgovor.dani === "string"
//                 ? JSON.parse(selectedChat.odgovor.dani)
//                 : selectedChat.odgovor.dani
//               ).map((day, index) => (
//                 <div
//                   key={index}
//                   className="border border-gray-300 rounded-lg p-4 bg-gray-50"
//                 >
//                   <h4 className="text-lg font-medium text-gray-800 mb-2">
//                     {day.dan || `Dan ${index + 1}`}
//                   </h4>
//                   {Object.entries(day).map(([mealKey, mealValue]) => {
//                     if (mealKey !== "dan" && typeof mealValue === "object") {
//                       return (
//                         <div key={mealKey} className="mb-4">
//                           <h5 className="font-semibold text-gray-800 capitalize mb-1">
//                             {mealKey.replace(/([A-Z])/g, " $1")}
//                           </h5>
//                           <div className="ml-4 space-y-1">
//                             {Object.entries(mealValue).map(([subKey, subValue]) => (
//                               <p key={subKey} className="text-sm text-gray-700">
//                                 <strong>{subKey.replace(/([A-Z])/g, " $1")}: </strong>
//                                 {subValue || "N/A"}
//                               </p>
//                             ))}
//                           </div>
//                         </div>
//                       );
//                     }
//                     return null;
//                   })}
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Ostali podaci iz odgovora */}
//         {selectedChat.odgovor && (
//           <div>
//             <h3 className="text-lg font-medium text-gray-900 mb-2">Odgovor</h3>
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               {Object.entries(selectedChat.odgovor).map(([key, value]) => {
//                 if (key === "dani") return null; // Dani su već prikazani
//                 return (
//                   <p key={key} className="text-sm text-gray-700">
//                     <strong>{key.replace(/([A-Z])/g, " $1")}: </strong>
//                     {value || "N/A"}
//                   </p>
//                 );
//               })}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Footer */}
//       <div className="mt-6 text-right">
//         <button
//           onClick={closeModalChat}
//           className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
//         >
//           Zatvori
//         </button>
//       </div>
//     </div>
//   </div>
// )}

{
  /* Chet komunikacija */
}
// {currentTab === "Čet konverzcija" && (
//   <div className="block w-full h-max rounded bg-white p-2 border-gray-300">
//     {/* Dropdown za mobilne uređaje */}
//     <div className="sm:hidden">
//       <label htmlFor="sub-tabs-chat" className="sr-only">
//         Select a sub-tab
//       </label>
//       <select
//         id="sub-tabs-chat"
//         name="sub-tabs-chat"
//         className="block w-full rounded border-gray-300 focus:border-blue-500 focus:ring-blue-500"
//         value={currentSubTabChetConv}
//         onChange={handleSubTabSelectChangeChatConv}
//       >
//         {subTabsChat.map((subTab) => (
//           <option key={subTab.name} value={subTab.name}>
//             {subTab.name}
//           </option>
//         ))}
//       </select>
//     </div>

//     {/* Navigacija za desktop */}
//     <div className="hidden sm:block">
//       <nav
//         className="isolate flex divide-x divide-gray-200 rounded shadow"
//         aria-label="Sub-tabs"
//       >
//         {subTabsChat.map((subTab, subTabIdx) => (
//           <a
//             key={subTab.name}
//             href={subTab.href}
//             onClick={(e) => {
//               e.preventDefault();
//               handleSubTabSelectChangeChatConv(subTab.name);
//             }}
//             className={classNames(
//               subTab.name === currentSubTabChetConv
//                 ? "text-gray-900"
//                 : "text-gray-500 hover:text-gray-700",
//               subTabIdx === 0 ? "rounded-tl rounded-bl" : "",
//               subTabIdx === subTabsChat.length - 1
//                 ? "rounded-tr rounded-br"
//                 : "",
//               "group relative w-1/2 overflow-hidden bg-white px-4 py-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
//             )}
//             aria-current={
//               subTab.name === currentSubTabChetConv ? "page" : undefined
//             }
//           >
//             <span>{subTab.name}</span>
//             <span
//               aria-hidden="true"
//               className={classNames(
//                 subTab.name === currentSubTabChetConv
//                   ? "bg-blue-500"
//                   : "bg-transparent",
//                 "absolute inset-x-0 bottom-0 h-0.5"
//               )}
//             />
//           </a>
//         ))}
//       </nav>
//     </div>

//     {/* Sadržaj za podtabove */}
//     <div className="color">
//       {currentSubTabChetConv === "Pregled" && (
//           <div className="block w-full h-100 bg-gray-100 p-2">
//           <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
//             <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
//               <div className="ml-4 mt-2">
//               <div className="flex items-center space-x-2">
//                 <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
//                   Svi chetovi
//                 </h3>
//               </div>

//               </div>
//               <div className="ml-4 mt-2 flex-shrink-0">
//                 {/* <button
//                   type="button"
//                   onClick={handleAddPrimCilj}
//                   className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
//                 >
//                   Dodaj
//                 </button> */}
//               </div>
//             </div>

//             <ul className="mt-4">
//               {primCiljevi?.map((job) => (
//                 <li key={job._id} className="flex justify-between items-center border-b border-gray-200 py-3">
//                   <span className="text-md font-semibold text-gray-900">
//                     {job.naziv}
//                   </span>
//                   <div className="flex items-center">
//                     <button
//                       onClick={() => openEditModalPrimCilj(job)}
//                       className="ml-4 text-blue-600 hover:text-blue-500"
//                     >
//                       Izmeni
//                     </button>
//                     <button
//                       onClick={() => handleDelPrimCilj(job._id)}
//                       className="ml-4 text-red-600 hover:text-red-500"
//                     >
//                       Ukloni
//                     </button>
//                   </div>
//                 </li>
//               ))}

//             </ul>
//           </div>

//         </div>
//       )}
//     </div>
//   </div>
// )}
